import $ from 'jquery';
import 'jquery-validation';
import 'jquery-ui/ui/widgets/tooltip';
import pRadio from 'kpc/components/radio';
import Tooltip from 'kpc/components/tooltip';
import pInput from 'kpc/components/input';
import pButton, {ButtonGroup} from 'kpc/components/button';
import * as commonConst from '../../store/common/constants';
// import KecSelect from 'ksc-vue-ui2/src/components/kecSelect/select.vue';
import pForm, {FormItem} from 'kpc/components/form';
import Spinner from 'kpc/components/spinner';
import Dialog from 'kpc/components/dialog';
import Pagination from 'kpc/components/pagination';
import pTable, {TableColumn} from 'kpc/components/table';
import {mapState} from 'vuex';
import Intact from 'intact';
import Message from 'kpc/components/message';
import moment from 'moment';
import {Select, OptionGroup, Option} from 'kpc/components/select';
import * as step1Const from '../../store/create/step1/constants';
import cloudmarketDia from '../new-step-createKec/cloudmarketDia/index.vue';
import snapCreateDia from '../new-step-createKec/snapCreateDia/index.vue';
import Checkbox from 'kpc/components/checkbox';
import DateUtil from '../../services/common/DateUtil';
import Vue from 'vue';
import KsGroupSelect from 'ksc-vue-ui2/src/components/KsSelect/index.vue';
import KsPagesNewStyle from 'ksc-vue-ui2/src/components/KsPagesNewStyle/index.vue';
import KsTableAdv from 'ksc-vue-ui2/src/components/KsTableKvm/index.vue';
import KsTableAdvColumn from 'ksc-vue-ui2/src/components/KsTableAdvColumn/index.vue';
import Slider from 'kpc/components/slider';
import commonCookie from '../../services/common/cookie';
import * as _ from 'lodash';
import Card from 'kpc/components/card';

function getQueryString(name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    let result = window.location.hash.split('?')[1] || '';
    let valid = result.match(reg);
    if (valid != null) {
        return decodeURIComponent(valid[2]);
    } else {
        return null;
    }
}

export default {
    data() {
        return {
            priceSet: {},
            moment,
            imageType: 0,
            isAndroidImage: false,
            DateUtil,
            isShow: false,
            gameImageList: [],
            osImageList: [],
            imageObj: {},
            kecTypeList: [],
            kecType: '96',
            isEnhance: false,
            dedicatedPackage: [],
            billTypeList: [],
            newBillTypeList: [],
            billType: '',
            regionList: [],
            newRegionList: [],
            regionKey: 'cn-qingyangtest-1',
            azList: [],
            az: '',
            dedicatedObj: {},
            diyImgList: [],
            model: {
                cpu: '',
                mem: '',
                disk: '',
                dedicateCount: 1
            },
            isWindows: false,
            isWin2008: false,
            isUbuntu: false,
            systemDisk: {min: 0, max: 0, value: 0},
            azDedicateCollect: {},
            isShowSnapDia: false,
            size: 10,
            current: 1,
            snapSearch: '',
            snapBtnDisabled: true,
            snapObj: {},
            // isSnapToCreate: false,
            snapId: '',
            dedicatedNumLimit_src: 70,
            dedicatedNumLimit: 50,//限制专属虚拟机可开机最大数量
            dedicatedDiskCopy: '',
            onTrail: false,
            clusterObj: '',
            clusterList: [],
            clusterAZList: [],
            shareImageListCopy: [],
            shareImgList: [],

            systemDiskTypes: [],
            systemDiskType: '',
            diskTypes: [],
            diskObj: {},
            //snap
            snapListLoading: false,
            snapPage: {
                current: 1,
                totalRows: 0,
                rowsPerPage: 10
            },
            snapEbsPage: {
                current: 1,
                totalRows: 0,
                rowsPerPage: 10
            },
            snapDefault: [],
            snapInfo: {
                snapChoose: false,
                showDelete: false,
                snapId: '',
                snapName: '',
                snapCpacity: ''
            },
            snapInfoClick: {
                snapId: '',
                snapName: '',
                snapCpacity: ''
            },
            // snapNum: 10,
            snapBtnStatus: true,
            isSnapCreateDisk: false, //快照开机，控制弹框
            canSnapCreateDisk: true, //是否展示快照开机功能
            diskSize: 0,
            cloneDiskSize: 50,
            checkedProject: '',
            cpuCollect: {},
            cpuList: [],
            cpu: '',
            memCollect: {},
            memList: [],
            mem: '',
            sysDiskObjValue: '',
            diskObjValue: '',
            isLocalSystemSSD: true,
            ebsDiskSizeList: [],
            maxEbsNum: -1,
            hadEbsDisk: 0,
            ebsDiskObj: {},
            ebsDiskObjs: [],
            ebsDiskTypes: [{
                title: this.$trans(`没有配置任何数据盘`),
                value: ''
            }],
            hasDiscount: false,
            limitNum: 50,
            kecCount: 1,
            tryOrderMethod: {
                billTypeName: this.$trans(`试用`),
                billTypeId: 2017
            },
            focusStatus: false,
            tryOrderDay: 1,
            duration: '1',
            kecPrice: 0,
            isHasEnhance: false,
            enhanceList: [],
            enhanceType: {},
            gpuCollect: {},
            gpuList: [],
            gpu: '',
            soldOutTypeList: [],
            allDiskNameMap: {
                'Local_SSD': this.$trans(`本地SSD`),
                'SSD': this.$trans(`云硬盘2.0（SSD）`),
                'SATA': this.$trans(`云硬盘2.0（SATA）`),
                'SSD3.0': this.$trans(`云硬盘3.0（SSD）`),
                'EHDD': this.$trans(`高效云盘`), // 高效云盘
                'ESSD': this.$trans(`ESSD云硬盘`), // ESSD云盘
            },
            ebsNameMap: {
                'SSD': this.$trans(`云硬盘2.0（SSD）`),
                'SATA': this.$trans(`云硬盘2.0（SATA）`),
                'SSD3.0': this.$trans(`云硬盘3.0（SSD）`),
                'EHDD': this.$trans(`高效云盘`), // 高效云盘
                'ESSD': this.$trans(`ESSD云硬盘`), // ESSD云盘
                // 'SSD':  this.$trans(`云硬盘（SSD）`),
                // 'SATA': this.$trans(`云硬盘（SATA）`),
                // 'SSD3.0': this.$trans(`云硬盘3.0（SSD）`),
                //'云硬盘3.0(SSD)'
                //'云硬盘2.0(SATA)',//this.$trans(`云硬盘（SATA）`), //'云硬盘(SATA)',
                //'云硬盘2.0(SSD)',//this.$trans(`云硬盘（SSD）`), //'云硬盘osImages(SSD)',
            },
            //主机类型描述
            productTipMap: {
                40: [this.$trans(`适合各个行业通用计算需求，如：小型 Web 应用、中小型数据等。`)],
                41: [this.$trans(`IO优化型I1实例是高磁盘IO的最佳选择，提供每秒数万次低延迟性随机 操作（IOPS）。`), this.$trans(`适合于低延时、I/O密集型应用。`)],
                45: [this.$trans(`适合于低延时、I/O密集型应用。`)],
                42: [this.$trans(`采用Intel Xeon E5-2680 v3 （Haswell） 处理器，2.5GHz的主频，DDR4内存。`), this.$trans(`建议用于游戏服务器、数据库服务器。`)],
                80: [
                    this.$trans(`采用Intel Xeon E5-2667 v4 （Broadwell） 处理器，3.2GHz的超高主频，DDR4内存。`),
                    this.$trans(`计算优化型C2实例是高计算性能和高并发读写的应用的最佳选择。`),
                    this.$trans(`建议用于大型游戏服务器、高性能计算以及其他计算密集型应用。`)
                ],
                78: [
                    this.$trans(`采用Intel Xeon E5-2690 v4 （Broadwell） 处理器，2.6GHz的高主频，DDR4内存。`),
                    this.$trans(`IO优化型I2实例是高磁盘IO的最佳选择，提供每秒数万次低延迟性随机 I/O 操作（IOPS）。`),
                    this.$trans(`适合于低延时、I/O密集型应用，建议用于游戏服务器、数据库服务器。`)
                ],
                43: [this.$trans(`存储优化型`)],
                77: [
                    this.$trans(`GPU通用计算型（P3）实例使用NVIDIA P40 型GPU加速卡单卡拥有12TFlops的单精度浮点运算能力和24GB显存。`),
                    this.$trans(`可以用于深度学习的训练与推理预测场景，也可以用于其他通用计算加速场景。`)
                ],
                101: [this.$trans(`GPU推理计算型P3I实例使用NVIDIA P4 型GPU加速卡，拥有单卡5.6TFlops的单精度浮点运算能力和8GB显存。`), this.$trans(`可以用于深度学习的推理场景，被称为推理加速器，也可以结合GRID方案，用于桌面渲染。`)],
                110: [this.$trans(`2.7 GHz Intel Xeon® Platinum 8168 处理器，DDR4内存。`), this.$trans(`高磁盘 IO 负载，低延迟高吞吐`), this.$trans(`适用于MMOGPG、MOBA游戏前端等场景`)],
                111: [this.$trans(`3.2 GHz Intel Xeon® Gold 6146  处理器，睿频高达3.6 GHz。DDR4内存。`), this.$trans(`高计算性能和高并发读写`), this.$trans(`适用于高负载数据库、高负载web等场景`)],
                137: [this.$trans(`2.6GHz Intel Xeon E5-2690 v4 处理器，DDR4内存`), this.$trans(`适合中小规模的企业级应用，数据库、缓存、搜索集群，以及中小型Web应用、手机应用等对资源没有特殊要求场景。`)],
                142: ['GPU推理计算型P3IN使用NVIDIA P4型加速卡，拥有单卡5.6TFLOPS单精度浮点运算能力和8GB显存，可以用于深度学习的推理场景被称为推理加速器，也可用于训练场景'],
                125: ['GPU通用计算型P4V使用NVIDIA V100型加速卡，拥有单卡15TFLOPS单精度浮点运算能力以及125TFLOPS混合精度矩阵运算能力，16GB显存，使深度学习训练与推理过程有3X倍性能提升'],
                126: [this.$trans(`GPU图形计算型P4V使用AMD S7150型加速卡，拥有单卡3.77TFLOPS单精度浮点运算能力以及250 GFLOPS双精度浮点运算能力，8GB显存。`), this.$trans(`能够轻松加速应用程序和处理复杂的计算工作流,适用于远程图形工作站、云游戏，云计算、VDI等虚拟领域使用场景。`)],
                152: [this.$trans(`2.6 GHz Intel Xeon® Gold 6132 处理器，DDR4内存`), this.$trans(`平衡的计算、内存和网络资源`), this.$trans(`适用于各种类型和规模的企业级应用及数据库等场景`)], //s3机型描述信息
                138: [this.$trans(`2.6 GHz Intel Xeon E5-2690 v4 处理器，DDR4内存`), this.$trans(`高磁盘 IO 负载，低延迟高吞吐`), this.$trans(`适用于高负载web服务及需要低时延的I/O密集型应用`)], //x2机型描述信息
            },
            kecName: '',
            subnet: {},
            subnetId: '',
            secgroup: {},
            secgroupId: '',
            ebsSupport: [],
            MaxReignSnap: '',
            snapNameMap: {
                'active': this.$trans(`完成`), //完成
                'restoring': this.$trans(`回滚中`), //回滚中
                'saving': this.$trans(`创建中`), //  创建中
                'unknown': this.$trans(`未知错误`), //未知状态
                'error': this.$trans(`错误`), //错误
                'queued': this.$trans(`排队中`), //排队中
                'deleted': this.$trans(`主机已删除`) //主机已删除
            },
            ebsSnaps: [],
            ebsSnapList: [],
            ebsSnapListClone: [],
            isSnapCreateEbs: false,
            snapSearchEbs: '',
            snapBtnEbsStatus: true,
            snapEbsIdx: 0,
            kecinfo: {},
            vkdc_group_TypeList: [],
            ebs_group_TypeList: [],
            systemDiskMax: 500,
            systemDiskMin: 0,
            systemDiskStep: 1,
            systemDiskSize: 0,
            systemDiskUnit: 'GB',
            systemDiskObj: {},
            isShowSlider: false,
            isEbsSystemDisk: '',
            localSystemDiskSize: 0,
            // shareImageListCopy: [],
            // shareImgList: [],
            isShowMarket: false,
            hasEbsModel: false,
            isDN2: false,
            pageLanguage: 'zh',
            orderBill: '',
            isGpu: '',
            maxCpuNum: 0,
            dedicatedId: '',
            assembledImageMetaNum: 0,
            delWithInsList: [],
            systemDiskTypesCopy: [],
            imageId: '',
            sourcePage: getQueryString('sourcePage') || "",
            osImageId: '',
            osRegionKey: '',
            isAllClouldDisk: false,
            SupportProductTypes: [],
        };
    },
    components: {
        pRadio, Tooltip,
        pButton,
        // KecSelect,
        ButtonGroup,
        pInput, pForm, FormItem, Spinner, Dialog,
        pTable, TableColumn, Pagination,
        cloudmarketDia,
        snapCreateDia,
        Select, OptionGroup, Option,
        Checkbox,
        KsPagesNewStyle, KsTableAdv, KsTableAdvColumn, KsGroupSelect,
        Slider,
        Card
    },
    props: {
        isGameUser: {
            type: Boolean,
            default: false
        },
        // 是否容器
        isCluster: {
            type: Boolean,
            default: false,
            required: false
        },
        locals: {
            type: Object,
            default: () => {
                return {}
            },
            required: false
        },
        dedicateCount: {
            type: Number,
            default: 1,
            required: false
        }
    },
    watch: {
        kecType() {
            if (this.kecType == '603') {
                this.model.disk = 0;
            }
            this.formateOsImage();
            this._setImageId()
        },
        imageType() {
            this.imageId = ''
            this.imageObj = {}
            if (this.model.disk) {
                this.model.disk = 0
                this.snapInfo.snapChoose = false
                this.snapInfo.showDelete = true
            }
            this._setImageId()
            this.exportData()
        },
        imageId(val, oldVal) {
            if (val !== oldVal) {
                if (this.imageType == 0 || this.imageType == 2) {
                    for (let i = 0, len = this.osList.length; i < len; i++) {
                        let obj = _.find(this.osList[i].images, (item) => {
                            return val === item.imageId
                        })
                        this.imageObj = obj
                        if (obj) {
                            return
                        }

                    }
                }
                if (this.imageType == 1) {
                    let obj = _.find(this.diyOsList, (item) => {
                        return val === item.imageId
                    })
                    this.imageObj = obj
                    if (obj) {
                        return
                    }
                }
                if (this.imageType == 3) {
                    let obj = _.find(this.shareOsList, (item) => {
                        return val === item.imageId
                    })
                    this.imageObj = obj
                    if (obj) {
                        return
                    }
                }
            }

        },
        imageObj(val) {
            this._onImageChange()
            if (_.keys(val).length) {
                this.imageId = val.imageId
                this.feachAssembledImageMeta();

                // 本地镜像 只支持SSSD3.0
                if (this.systemDiskTypesCopy.length) {
                    let systemDiskTypes = _.cloneDeep(this.systemDiskTypesCopy);
                    if (_.get(val, 'Type') == 'LocalImage' && _.get(val, 'AvailabilityZone') == this.az && (this.imageType == 1 || this.imageType == 3)) {
                        let tempObj = _.filter(systemDiskTypes, (item) => {
                            return item.value == 'SSD3.0';
                        }) || {};
                        this.systemDiskTypes = tempObj;
                        this.sysDiskObj = tempObj[0];
                        this.sysDiskObjValue = tempObj[0].value;
                    } else {
                        this.systemDiskTypes = systemDiskTypes;
                        this.sysDiskObj = systemDiskTypes[0];
                        this.sysDiskObjValue = systemDiskTypes[0].value;
                    }
                }
                if (this.kecType == '603') {
                    let num = 0;
                    if (!this.isAndroidImage) {
                        num = 1;
                    } else {
                        num = _.get(this.dedicatedObj, 'lessNum', 0);
                    }
                    this.$emit('changeLimitNum', num);
                }
            }

        },
        dedicatedObj(val) {
            this.dedicatedId = typeof val === 'object' && val !== null ? val.DedicatedHostId : ''
            this.setKecTypeWithDedicated()
            let oriCpu = _.get(this.dedicatedObj, 'OriCpu', 0);
            let availableCpu = _.get(this.dedicatedObj, 'AvailableCpu', 0);
            this.maxCpuNum = oriCpu <= availableCpu ? oriCpu : availableCpu;
        },
        dedicatedId(val) {
            // if (!val) {
            //     return;
            // }
            this.dedicatedObj = _.find(this.azDedicateCollect[this.az], item => {
                return item.DedicatedHostId === val
            }) || {}
            this.isAllClouldDisk = this.dedicatedObj.TotalDatadisk ? false : true;
        },
        regionKey(val) {
            this.resetSnap();
            this._fetchExCluster();
        },
        'dedicatedObj.lessNum': {
            handler(val) {
                // if(!_.isEmpty(val) && val.DedicatedHostId) this.$checkValid();
                if (this.kecType == '603' && !this.isAndroidImage) { // gpu专属型 如果是centOS镜像创建，只能创建一个
                    val = 1;
                }
                this.$emit('changeLimitNum', val)
            }
        },
        az() {
            this._filterCluster()
            this.setKectypeListwithAz()

        },
        clusterObj() {
            this.clusterObjChange()
        },
        model: {
            deep: true,
            handler(val) {
                this.$checkValid();
            }
        },
        systemDisk: {
            deep: true,
            handler(val, old) {
                this.exportData();
            }
        },
        sysDiskObjValue(item) {
            // console.log(item, 123123);
            this._showSlider(item);
            if (item === 'Local_SSD') {
                if (this.kecType == '603') {
                    this.model.disk = 0;
                }
                this.localSystemDiskSize = 0; //重置本地盘默认值
                this.isLocalSystemSSD = true
            } else {
                this.localSystemDiskSize = 50; //赋值本地盘让其通过效验规则
                this.model.disk = 0;
                this.isLocalSystemSSD = false;
            }
            this.exportData();
        },
        systemDiskSize() {
            if (this.systemDiskSize < this.systemDiskObj.minValue) {
                this.systemDiskSize = this.systemDiskObj.minValue
            }
            this.exportData();
        },
        ebsDiskSizeList() {
            var l = this.hadEbsDisk;
            if (l > 0) {
                for (var i = 0; i < l; i++) {
                    try {
                        var ele = $(this.$el).find('[name="ebsDisk' + i + '"]');
                        if (ele) {
                            ele.valid();
                        }
                    } catch (e) {

                    }

                }
            }
        },
        snapPage(val, old) {
            val.current != old.current ? this._snapCreate() : undefined;
            val.rowsPerPage != old.rowsPerPage ? (this.snapPage.current = 1, this._snapCreate()) : undefined;
        },
        snapEbsPage(val, old) {
            val.current != old.current ? this._snapCreateEbs() : undefined;
            val.rowsPerPage != old.rowsPerPage ? (this.snapEbsPage.current = 1, this._snapCreateEbs()) : undefined;
        },
        dedicateCount(val) {
            this.model.dedicateCount = val
        }
    },
    created() {
        var self = this;

        // 获取页面当前语言
        this.pageLanguage = window.KSC_SECNET_CONSOLE.LANG || 'zh';

        pForm.addMethod("dedicateCpu", function (value, element) {
            if (!self.dedicatedObj.DedicatedHostId || self.dedicatedObj.DedicatedHostId != 'auto')
                return self.dedicateCpuCal();
            return true;
        }, self.$trans(`CPU不足以分配`)); //CPU不足以分配
        pForm.addMethod("dedicateMem", function (value, element) {
            if (!self.dedicatedObj.DedicatedHostId || self.dedicatedObj.DedicatedHostId != 'auto')
                return self.dedicateMemCal();
            return true;
        }, self.$trans(`内存不足以分配`)); //内存不足以分配
        pForm.addMethod("dedicateDisk", function (value, element) {
            if (this.kecType == '603') {
                return true;
            }
            if (!self.dedicatedObj.DedicatedHostId || self.dedicatedObj.DedicatedHostId != 'auto')
                return self.dedicateDiskCal();
            return true;
        }, self.$trans(`数据盘不足以分配`));
        pForm.addMethod("actualCpu", function (value, element) {
            if (!self.dedicatedObj.DedicatedHostId || self.dedicatedObj.DedicatedHostId != 'auto')
                return self.dedicateActualCpuCal();
            return true;
        }, self.$trans(`单台可分配的最大核数不可超过实际核数`));
        pForm.addMethod('dedicatelimit', function (value, element) {
            // return (value <= self.dedicatedObj.lessNum && value <= 50) || `当前机型最大可开数量${self.dedicatedObj ? (self.dedicatedObj.lessNum?self.dedicatedObj.lessNum:50) : 50}`;//self.$trans(`您的帐号仅支持最多批量购买{0}台`, self.dedicatedNumLimit);
            return (value <= self.dedicatedObj.lessNum) || `当前机型最大可开数量${self.dedicatedObj ? self.dedicatedObj.lessNum : 50}`;
        });
        pForm.addMethod('imageRequired', function (value, element) {
            return !!self.imageObj.imageId;
        }, self.$trans(`请先选择镜像`));
        pForm.addMethod('kecTypeRequired', function (value, element) {
            return !!self.kecType;
        }, 'oh no');

        pForm.addMethod("localSystemDiskSizeRules", function (value, element) {
            if (self.kecType == '603' && self.isLocalSystemSSD) {
                return value >= self.systemDisk.value && value <= 500
            } else {
                return true;
            }
        }, self.$trans(`系统盘大小超出范围`)); //您可输入{0}-{1}G
    },
    computed: {
        ...mapState({
            common: state => state.__pbc__.common,
            // osImages: state => state.__pbc__.common.osImages,
            // pTypeConfig: state => state.__pbc__.common.pTypeConfig,
            imageSet: state => state.__pbc__.common.imageSet,
            //  宿主机和eip调用价格体系都会修改common.state.priceSet，切换上一步下一步会造成异常
            // priceSet: state => state.pcommon.priceSet,
            dedicatedList: state => state.__pbc__.common.dedicatedList,
            projList: state => state.__pbc__.common.projList,
            snapList: state => state.__pbc__.common.snapList,
            snapListTotal: state => state.__pbc__.common.snapListTotal,
            // snapNum: state => state.pcommon.lessSnapNum,
            regionInfos: state => state.__pbc__.common.regionInfos
        }),
        osList() {
            if (this.imageType == 0) {
                return this._filterOsImage(this.osImageList);
            }

            if (this.imageType == 2 && this.isGameUser) {
                return this._filterOsImage(this.gameImageList);
            }
            return [];
        },

        diyOsList() {
            if (this.imageType == 1) {
                let osList = this.diyImgList;
                if (this.orderBill == 2017) {
                    osList = _.filter(osList, item => {
                        return !item.IsCloudMarket
                    })
                }
                

                const propertyList = (_.find(this.vkdc_group_TypeList, ['productTypeId', this.kecType * 1]) || {}).propertyList
                const bootMode = _.find(propertyList, ['propCode', 'BOOT_MODE'])?.propValue[0]?.value || 'BIOS(Legacy)';
                
                if (this.hasEbsModel) {
                    

                    //2019-08-15 同云主机逻辑 本地盘主机自定义镜像支持开云盘主机
                    osList = _.filter(osList, (item) => {
                        //本地盘镜像需要同可用区才能支持
                        let isLocalImage = true;
                        if (item.Type == 'LocalImage') {
                            if (item.AvailabilityZone != this.az) {
                                isLocalImage = false;
                            }
                        }
                        return item.ImageState == 'active' && item.SysDisk <= 500 && isLocalImage; //DN2机型最大支持到500G
                    });
                    console.log('this.maxEbsNum:::', this.maxEbsNum)
                    _.forEach(osList, item => {
                        item.disabled = false;
                        item.tipInfo = '';

                        if(bootMode !== 'both'){
                            if(bootMode.toLowerCase() !== item.BootMode?.toLowerCase()){
                                item.disabled = true;
                                item.tipInfo = '1300';
                            }
                            
                        }
                        
                        let SnapshotSets = _.filter(item.SnapshotSet, item => item.Type === 'data') || [];
                        if(SnapshotSets.length > this.maxEbsNum){
                            item.disabled = true
                            item.tipInfo = '1200'
                        }
                    })

                } else {
                    //2019-08-15 同云主机逻辑
                    osList = _.filter(osList, (item) => {
                        //SnapshotSet.length 大于1 为判定为整机镜像包括数据盘，目前只有DN2机型支持整机镜像带云盘数据盘
                        // let SnapshotSet = _.get(item, 'SnapshotSet', []);
                        // && SnapshotSet.length <= 1
                        return item.ImageState == 'active' && item.SysDisk <= 50 && item.Type != 'LocalImage';
                        ; //本地盘机型不支持本地镜像
                    });
                    let canUseOsList = [], disableOsList = []
                    _.forEach(osList, item => {
                        item.disabled = false;
                        item.tipInfo = '';

                        if(bootMode !== 'both'){
                            if(bootMode.toLowerCase() !== item.BootMode?.toLowerCase()){
                                item.disabled = true;
                                item.tipInfo = '1300';
                            }
                            
                        }

                        let SnapshotSet = _.get(item, 'SnapshotSet', []);
                        if (SnapshotSet.length <= 2) {
                            // if (SnapshotSet.length && SnapshotSet[SnapshotSet.length - 1].DiskType === 'ebs_snapshot') {
                            //     item.disabled = true
                            //     disableOsList.push(item)
                            //     return
                            // }

                            //本地虚机支持系统盘为云盘的镜像, 但数据盘不支持云盘
                            let systemDisk = _.filter(SnapshotSet, (item) => {
                                return item.Type === 'system';
                            }) || [];
                            let dataDisk = _.filter(SnapshotSet, (item) => {
                                return item.Type === 'data';
                            }) || [];

                            if (systemDisk.length && systemDisk[0].DiskType === 'ebs_snapshot') {
                                if (dataDisk.length && dataDisk[0].DiskType === 'ebs_snapshot') {
                                    item.disabled = true;
                                    disableOsList.push(item);
                                    return;
                                }
                            } else {
                                if (dataDisk.length && dataDisk[0].DiskType === 'ebs_snapshot') {
                                    item.disabled = true;
                                    disableOsList.push(item);
                                    return;
                                }
                            }

                            // //ARM机型 只支持带 aarch64 标记的自定义镜像
                            // if (item.Architecture && item.Architecture == "aarch64") {
                            //     item.disabled = true; //禁止当前选项
                            //     disableOsList.push(item);
                            //     return;
                            // }

                            if (this.kecType == '603') { //GPU专属型虚机需要支持 aarch64 的镜像 包括安卓镜像
                                if (item.Architecture && item.Architecture == "aarch64") {
                                    console.log('支持GPU专属型的自定义镜像');
                                } else {
                                    item.disabled = true; //禁止当前选项
                                    // item.tipInfo = '600';
                                }
                            } else {
                                //ARM机型 只支持带 aarch64 标记的自定义镜像
                                if (item.Architecture && item.Architecture == "aarch64") {
                                    item.disabled = true; //禁止当前选项
                                    // item.tipInfo = '600';
                                }
                            }

                            canUseOsList.push(item);
                        } else {
                            //超过1块数据盘的镜像禁用
                            item.disabled = true;
                            disableOsList.push(item);
                        }
                    });
                    osList = [...canUseOsList, ...disableOsList]
                }

                return osList;
            }
            return [];
        },
        shareOsList() {
            if (this.imageType == 3) {
                this.shareImageListCopy = _.clone(this.shareImgList);
                let osList = this.shareImageListCopy;
                if (this.orderBill == 2017) {
                    osList = _.filter(osList, item => {
                        return !item.IsCloudMarket
                    })
                }

                const propertyList = (_.find(this.vkdc_group_TypeList, ['productTypeId', this.kecType * 1]) || {}).propertyList
                const bootMode = _.find(propertyList, ['propCode', 'BOOT_MODE'])?.propValue[0]?.value || 'BIOS(Legacy)';
                
                if (this.hasEbsModel) {
                    //2019-08-15 同云主机逻辑 本地盘主机自定义镜像支持开云盘主机
                    osList = _.filter(osList, (item) => {
                        //本地盘镜像需要同可用区才能支持
                        let isLocalImage = true;
                        if (item.Type == 'LocalImage') {
                            if (item.AvailabilityZone != this.az) {
                                isLocalImage = false;
                            }
                        }
                        return item.ImageState == 'active' && item.SysDisk <= 500 && isLocalImage; //DN2机型最大支持到500G
                    });
                    _.forEach(osList, item => {
                        item.disabled = false;
                        item.tipInfo = '';

                        if(bootMode !== 'both'){
                            if(bootMode.toLowerCase() !== item.BootMode?.toLowerCase()){
                                item.disabled = true;
                                item.tipInfo = '1300';
                            }
                            
                        }

                        let SnapshotSets = _.filter(item.SnapshotSet, item => item.Type === 'data') || [];
                        if(SnapshotSets.length > this.maxEbsNum){
                            item.disabled = true
                            item.tipInfo = '1200'
                        }
                    })
                } else {
                    //2019-08-15 同云主机逻辑
                    osList = _.filter(osList, (item) => {
                        // 如果镜像系统盘小于50G，则放行
                        //SnapshotSet.length 大于1 为判定为整机镜像包括数据盘，目前只有DN2机型支持整机镜像带云盘数据盘
                        // let SnapshotSet = _.get(item, 'SnapshotSet', []);
                        return item.ImageState == 'active' && item.SysDisk <= 50 && item.Type != 'LocalImage'; //本地盘机型不支持本地镜像
                    });
                    let canUseOsList = [], disableOsList = []
                    _.forEach(osList, item => {
                        item.disabled = false;
                        item.tipInfo = '';

                        if(bootMode !== 'both'){
                            if(bootMode.toLowerCase() !== item.BootMode?.toLowerCase()){
                                item.disabled = true;
                                item.tipInfo = '1300';
                            }
                            
                        }
                        let SnapshotSet = _.get(item, 'SnapshotSet', []);
                        if (SnapshotSet.length <= 2) {
                            // if (SnapshotSet.length && SnapshotSet[SnapshotSet.length - 1].DiskType === 'ebs_snapshot') {
                            //     item.disabled = true
                            //     disableOsList.push(item)
                            //     return
                            // }

                            //本地虚机支持系统盘为云盘的镜像, 但数据盘不支持云盘
                            let systemDisk = _.filter(SnapshotSet, (item) => {
                                return item.Type === 'system';
                            }) || [];
                            let dataDisk = _.filter(SnapshotSet, (item) => {
                                return item.Type === 'data';
                            }) || [];

                            if (systemDisk.length && systemDisk[0].DiskType === 'ebs_snapshot') {
                                if (dataDisk.length && dataDisk[0].DiskType === 'ebs_snapshot') {
                                    item.disabled = true;
                                    disableOsList.push(item);
                                    return;
                                }
                            } else {
                                if (dataDisk.length && dataDisk[0].DiskType === 'ebs_snapshot') {
                                    item.disabled = true;
                                    disableOsList.push(item);
                                    return;
                                }
                            }

                            // //ARM机型 只支持带 aarch64 标记的自定义镜像
                            // if (item.Architecture && item.Architecture == "aarch64") {
                            //     item.disabled = true; //禁止当前选项
                            //     disableOsList.push(item);
                            //     return;
                            // }

                            if (this.kecType == '603') { //GPU专属型虚机需要支持 aarch64 的镜像 包括安卓镜像
                                if (item.Architecture && item.Architecture == "aarch64") {
                                    console.log('支持GPU专属型的自定义镜像');
                                } else {
                                    item.disabled = true; //禁止当前选项
                                    // item.tipInfo = '600';
                                }
                            } else {
                                //ARM机型 只支持带 aarch64 标记的自定义镜像
                                if (item.Architecture && item.Architecture == "aarch64") {
                                    item.disabled = true; //禁止当前选项
                                    // item.tipInfo = '600';
                                }
                            }

                            canUseOsList.push(item);
                        } else {
                            //超过1块数据盘的镜像禁用
                            item.disabled = true;
                            disableOsList.push(item);
                        }
                    });
                    osList = [...canUseOsList, ...disableOsList]
                }
                return osList;
            }
            return [];
        },

        res() {
            var formData = this.model;

            //云硬盘需要获取滑竿的大小
            if (!this.isLocalSystemSSD) {
                this.systemDisk.value = this.systemDiskSize;
            }

            let ebsOk = true;
            // console.log(this.hadEbsDisk, this.ebsDiskObjs.length, 23);
            if (this.hadEbsDisk && this.ebsDiskObjs.length) {
                // console.log(1111111111111111111111, this.priceSet);
                var dedicatedData = _.find(_.get(this.priceSet, 'data', []), (item) => {
                    return item.productGroupId == '101'
                }) || {};
                _.forEach(this.ebsDiskObjs, disk => {
                    let config = _.find(dedicatedData.productTypeList, ['productTypeId', disk.productType]);
                    // console.log(dedicatedData.productTypeList, disk, 1);
                    if (!config) {
                        ebsOk = false;
                        return;
                    }
                    // console.log(2);
                    // let packageItem = config.packageList[0];
                    // console.log(config.packageList, 33);
                    let packageItem = (() => {
                        let maxPackage = null;
                        _.forEach(config.packageList, item => {
                            if (!maxPackage) {
                                maxPackage = item;
                            } else {
                                let curMax = _.get(item, 'packageInfo[0].propValue[0].max');
                                let maxMax = _.get(maxPackage, 'packageInfo[0].propValue[0].max');
                                if (maxMax < curMax) {
                                    maxPackage = item;
                                }
                            }
                        });
                        return maxPackage;
                    })()
                    if (!packageItem) {
                        ebsOk = false;
                        return;
                    }
                    // console.log(3);
                    let regionItem = _.find(packageItem.refRegionList, ['regionCode', this.regionKey]);
                    if (!regionItem) {
                        ebsOk = false;
                        return;
                    }
                    // console.log(4);
                    let azItem = _.find(regionItem.azList, ['azCode', this.az]);
                    if (!azItem) {
                        ebsOk = false;
                        return
                    }
                    // console.log(5);
                    let hasDailySettlement = _.find(packageItem.refBillTypeList, ['billTypeId', 5]);
                    if (!hasDailySettlement) {
                        ebsOk = false;
                        return;
                    }
                    // console.log(6);
                });
            }


            // console.log(this.ebsDiskObjs, 1111);
            return {
                ebsOk,
                billType: this.billType,
                regionKey: this.regionKey,
                az: this.az,
                dedicatedObj: this.dedicatedObj,
                kecType: this.kecType,
                kecTypeObj: this.kecTypeList[0] || {},
                cpu: formData.cpu,
                mem: formData.mem,
                disk: formData.disk,
                systemDisk: this.systemDisk,
                imageObj: this.imageObj,
                imageType: this.imageType,
                count: formData.dedicateCount,
                onTrail: this.onTrail,
                snapObj: this.snapObj,
                snapInfo: this.snapInfo,
                // isSnapToCreate: this.isSnapToCreate,
                dedicatedClusterId: this.clusterObj && this.clusterObj != 'auto' ? this.clusterObj : '',
                ebsDiskSizeList: this.ebsDiskSizeList,
                delWithInsList: this.delWithInsList,
                hadEbsDisk: this.hadEbsDisk,
                ebsDiskObjs: this.ebsDiskObjs,
                orderBill: this.orderBill,
                ebsSnapList: this.ebsSnapList,
                sysDiskObjValue: this.sysDiskObjValue,
                diskObjValue: this.diskObjValue,
                systemDiskSize: this.systemDiskSize,
                isAllClouldDisk: this.isAllClouldDisk,
                localSystemDiskSize: this.localSystemDiskSize
            };
        },
        snapListRes() {
            let inst = this.dedicatedObj;
            let num = this.model.dedicateCount;
            let res = _.filter(this.snapList, (item) => {
                if (item.State.toUpperCase() != 'ACTIVE' && item.State.toUpperCase() != 'RESTORING') {
                    // item.trTitle = "提示：当前不支持处于" + this.common.nameMap(data.row.State) + "的快照";
                    item.trTitle = this.$trans(`提示：当前不支持处于{0}的快照`, this.common.snapNameMap(item.State.toLowerCase()));
                    item.disable = true;
                }
                // if (0 == this.snapNum) {
                //     // item.trTitle = '提示：当前使用快照在创建中的实例已满10台，请取消使用快照或稍后创建';
                //     item.trTitle = this.$trans(`当前使用快照在创建中的实例已满10台，请取消使用快照或稍后创建`);
                //     item.disable = true;
                // }
                // if (num > this.snapNum) {
                //     // item.trTitle = '提示：使用快照创建实例已超过10台，请关闭后重新填写数量';
                //     item.trTitle = this.$trans(`提示：使用快照创建实例已超过10台，请关闭后重新填写数量．`);
                //     item.disable = true;
                // }
                if (item.DiskSize * num > inst.AvailableDatadisk) {
                    // item.trTitle = '提示：数据盘不足以分配';
                    item.trTitle = this.$trans(`提示：数据盘不足以分配`);
                    item.disable = true;
                }
                return item;
            });
            return res;
        },
        // hasEbsModel() {
        //     // ((dedicatedObj || {}).AttachTag || 0) != 'SSD3.0'
        //     let productType = _.get(this.dedicateObj, 'OrderInfo.ProductType');
        //     // if () {}
        //     console.log(productType, typeof productType, 44444);
        //     return productType === 141;
        //     // console.log(this.dedicatedObj);
        // }
    },
    methods: {
        tryDoChunk(val, newVal) {
            let num = this.pageLanguage == 'zh' ? 9 : 6; //UI设计：中文版和英文版展示region数量有差异
            this[val].length && (this[newVal] = _.chunk(this[val], num));
        },
        isCommonModelType() {
            return commonConst.isCommonModelType(this.kecType);
        },
        snapCreateOk() {
            this.snapSearch = '';
            this.snapPage.current = 1;
            this.canSnapCreateDisk = false;
            this.snapInfo.snapId = this.snapInfoClick.snapId;
            this.snapInfo.snapName = this.snapInfoClick.snapName;
            this.snapInfo.snapCpacity = this.snapInfoClick.snapCpacity;
            this.snapInfo.snapChoose = true;
            this.snapInfo.showDelete = false;
            this.diskSize = this.snapInfo.snapCpacity;
            // this.limitNum = this.snapNum;
            if (this.kecCount > this.limitNum) {
                this.kecCount = this.limitNum;
            }
            this.$set(this, 'isSnapCreateDisk', false);
        },
        snapCreateClose() {
            this.snapPage.current = 1;
            this.snapSearch = '';
            this.$set(this, 'isSnapCreateDisk', false);
        },
        snapCreateEbsOk() {
            this.snapSearchEbs = '';
            this.snapEbsPage.current = 1;
            // this.canSnapCreateDisk = false;
            this.ebsSnapList[this.snapEbsIdx] = this.ebsSnapListClone[this.snapEbsIdx];
            this.ebsDiskSizeList[this.snapEbsIdx] = this.ebsSnapList[this.snapEbsIdx].snapCpacity;
            // this.diskSize = this.snapInfo.snapCpacity;
            setTimeout(() => {
                let ele = $(this.$el).find(`[name="ebsDisk${this.snapEbsIdx}"]`)
                ele.valid();
            }, 200);

            // this.limitNum = this.snapNum;
            if (this.kecCount > this.limitNum) {
                this.kecCount = this.limitNum;
            }
            this.$set(this, 'isSnapCreateEbs', false);
        },
        snapCreateEbsClose() {
            this.snapEbsPage.current = 1;
            this.snapSearchEbs = '';
            this.$set(this, 'isSnapCreateEbs', false);
        },
        exportData() {
            this.$emit('input', this.res)
        },
        setInitData(params) {
            _.map(_.keys(params), (key) => {
                if (key != 'isShow') {
                    this[key] = params[key];
                }
            });
            // console.log(this.regionKey, 123456)
            // this.regionKey = localStorage.geti()
            if (this.sourcePage == 'osImageView') {
                this.getOsImageViewData()
            }
            if (this.hasPrecondition) {
                return this.preconditionFunc(params.isShow);
            } else {
                this.isShow = params.isShow || false;
            }
        },
        getOsImageViewData() {
            try {
                let imageViewData = JSON.parse(localStorage.getItem('osImageViewData'));
                this.osImageId = imageViewData.osImageId || "";
                this.osRegionKey = imageViewData.osRegionKey || "";
                this.SupportProductTypes = imageViewData.SupportProductTypes || []
                console.log('this.osImageId::', this.osImageId, this.osRegionKey, this.SupportProductTypes)
                localStorage.removeItem('osImageViewData');
            } catch (e) {
                this.sourcePage = '';
            }
        },
        uniqKey(value, index) {
            return value.LocalVolumeSnapshotId;
        },
        btnDisFunc(c, nV, oV) {
            if (this.isShowSnapDia) {
                this.snapId = nV;
            }
            if (nV) {
                this.snapBtnDisabled = false;
            } else {
                this.snapBtnDisabled = true;
            }
        },
        selectSnap() {
            var res = _.find(this.snapListRes, (item) => {
                return item.LocalVolumeSnapshotId == this.snapId
            });
            this.snapObj = res || {};
            // this.isSnapToCreate = true;
            this.isShowSnapDia = false;
            this.model.disk = (res || {}).DiskSize || '';
        },
        resetSnap() {
            // this.isSnapToCreate = false;
            this.snapObj = {};
            this.model.disk = this.dedicatedDiskCopy;
        },
        cancelSelect() {
            this.isShowSnapDia = false;
        },
        snapDisableRow(data, index) {
            return data.disable;
        },
        currentChange(c, nV) {
            this.current = nV;
            return this.snapToCreate();
        },
        LimitChange(c, nV) {
            this.size = nV;
            return this.snapToCreate();
        },
        setItem(key, val) {
            this[key] = val;
        },
        snapClick(val) {
            if (!val.row.disable) {
                this.snapInfoClick.snapId = val.row.LocalVolumeSnapshotId;
                this.snapInfoClick.snapName = val.row.LocalVolumeSnapshotName;
                this.snapInfoClick.snapCpacity = val.row.DiskSize;
                this.snapBtnStatus = false;
            }
        },
        preconditionFunc(isShow) {
            var promise = $.Deferred();
            promise = $.when(this._fetchOSImage(), this._fetchDedicatedPackage(), this._fetchProjList(), this._fetchDiyImg(), this._getRegionInfos(), this._fetchExCluster());
            return promise.then((res) => {
            }, (e) => {
                Message.error(e.msg || e);
            }).then(() => {
                this.isShow = isShow;
                this._bindWatch();
            });
        },

        //机房改变时
        regionChange() {
            this._fetchProjList();
            this.initData();
            this.initDedicatedObj();
            this._fetchOSImage(); //标准镜像
            this._fetchDiyImg(); //自定义镜像
            this._fetchShareImg(); //共享镜像
        },

        _bindWatch() {
            // this.$watch('imageType', this._setImageId);
            // this.$watch('imageObj', this._onImageChange);
            // this.$watch('dedicatedObj', this.watchDedicatedObj);
            this.$watch('regionKey', this.regionChange);
            this.$watch('model.cpu', this.exportData);
            this.$watch('model.mem', this.exportData);
            this.$watch('model.disk', this.exportData);
            this.$watch('model.dedicateCount', this.exportData);
            this.$watch('az', this.initDedicatedObj);
            this.$watch('billType', this.exportData);
            this.$watch('clusterObj', this.exportData)
            this.$watch('ebsDiskSizeList', this.exportData);
            this.$watch('localSystemDiskSize', this.exportData);
        },
        _fetchProjList() {
            return this.$store.dispatch(commonConst.projList, {
                params: {
                    type: 'DescribeDedicatedHosts',
                    Region: this.regionKey
                }
            }).then((res) => {
                return this._fetchDedicatedList();
            }, (e) => {
                Message.error(e.msg || e);
            });

        },

        $checkValid(callback) {
            return this.$refs.dedicatedForm.validate()
            // .then((res) => {
            //     return _.isFunction(callback) && callback(res);
            // });
        },

        snapToCreate() {
            this.snapBtnDisabled = true;
            // if (!this.isSnapToCreate) {
            if (!_.get(this.snapInfo, 'snapChoose', false)) {
                this.dedicatedDiskCopy = this.model.disk;
            }
            var promise = $.Deferred();
            promise = $.when(this._fetchSnapList());
            // this._getSnapLessNum()del this in $.when
            return promise.then((res) => {

            }, (e) => {
                Message.error(e.msg || e);
            }).then(() => {
                this.isShowSnapDia = true;
            });
        },

        _fetchSnapList() {
            return this.$store.dispatch(commonConst.snapList, {
                params: {
                    Region: this.regionKey
                },
                data: {
                    "Marker": (this.current - 1) * this.size,
                    "MaxResults": this.size,
                    "Search": this.snapSearch,
                    "LocalVolumeCategory": "data"
                },
                options: {
                    isJSON: true
                }
            }).then((res) => {

            }, (e) => {
                Message.error(e.msg || e);
            });
        },

        _fetchDedicatedList() {
            return this.$store.dispatch(commonConst.DedicatedList, {
                params: {
                    Region: this.regionKey,
                    projectIds: '', //查询全部项目制改为传空； (_.map(this.projList, 'ProjectId')).join(','),
                    dedicatedClusterId: this.clusterObj && this.clusterObj != 'auto' ? this.clusterObj : ''
                },
                options: {
                    isJSON: true
                }
            }).then((res) => {
                var list = this.dedicatedList || [];
                if (list.length != 0) {
                    _.forEach(list, (item) => {
                        item.lessNum = this.dedicatedNumLimit_src - _.get(item, 'Instances', []).length;
                        item.disabled = item.lessNum <= 0 ? true : (_.get(item, 'OrderInfo.Status') != 2 ? true : false);
                        if (item.OrderInfo.InstanceType == 2) { //InstanceType: 实例类型 1:正式 2:试用
                            this.orderBill = 2017;
                            return item.DedicatedHostName = item.DedicatedHostName + '(' + this.$trans(`试用`) + ')'
                        } else {
                            this.orderBill = '';
                        }

                    });
                }
                var azDedicateCollect = {};

                var localDediInstance = localStorage.getItem('exclusiveObj');

                var _obj = localDediInstance && JSON.parse(localDediInstance);
                !_.isEmpty(list) && _.map(list, (item) => {
                    var zone = item.AvailabilityZone;
                    if (!azDedicateCollect[zone]) {
                        if (this.clusterObj && this.clusterObj != 'auto') {
                            azDedicateCollect[zone] = [{
                                DedicatedHostId: 'auto',
                                DedicatedHostName: this.$trans(`自动分配`),
                                lessNum: 0//this.dedicatedNumLimit
                            }];
                        } else {
                            azDedicateCollect[zone] = [{
                                DedicatedHostId: '',
                                DedicatedHostName: this.$trans(`请选择`),
                                lessNum: this.dedicatedNumLimit
                            }];
                        }
                        // console.log(this.clusterObj, 111222333444);
                    }

                    // 下拉菜单只显示运行中状态的宿主机
                    if (item.OrderInfo && item.OrderInfo.Status === 2) {
                        azDedicateCollect[zone].push(item);
                    }
                    // azDedicateCollect[zone].push(item);
                    if (this.clusterObj && this.clusterObj != 'auto') {
                        azDedicateCollect[zone][0].lessNum += item.lessNum
                    }
                    return item;
                });


                _.forEach(azDedicateCollect, (zoneData, zone) => {
                    if (zoneData.length === 1 && zoneData[0].DedicatedHostId === 'auto') {
                        azDedicateCollect[zone] = [{
                            DedicatedHostId: '',
                            DedicatedHostName: this.$trans(`请选择`),
                            lessNum: this.dedicatedNumLimit
                        }]
                    }
                });

                this.azDedicateCollect = azDedicateCollect;
                if (!_.isEmpty(_obj)) {
                    this.az = _obj.AvailabilityZone;
                    this.dedicatedObj = _.find(list, (item) => {
                        return item.DedicatedHostId == _obj.DedicatedHostId;
                    }) || {};
                    if (_.isEmpty(this.dedicatedObj)) {
                        var az = this.az;
                        if (!az) {
                            az = _.get(list, '[0].AvailabilityZone');
                        }
                        // console.log(azDedicateCollect, az, 1000000);
                        if (azDedicateCollect[az]) {
                            this.dedicatedObj = azDedicateCollect[az][0];
                        } else {
                            this.dedicatedObj = {
                                DedicatedHostId: '',
                                DedicatedHostName: this.$trans(`请选择`),
                                lessNum: this.dedicatedNumLimit
                            };
                        }
                    }
                    this.setKecTypeWithDedicated();
                } else {
                    var az = this.az;
                    if (!az) {
                        az = _.get(list, '[0].AvailabilityZone');
                    }
                    // console.log(azDedicateCollect, az, 1000000);
                    if (azDedicateCollect[az]) {
                        this.dedicatedObj = azDedicateCollect[az][0];
                    } else {
                        this.dedicatedObj = {
                            DedicatedHostId: '',
                            DedicatedHostName: this.$trans(`请选择`),
                            lessNum: this.dedicatedNumLimit
                        };
                    }
                    //     {
                    //     // DedicatedHostId: '',
                    //     // DedicatedHostName: this.$trans(`请选择`),
                    //     // lessNum: this.dedicatedNumLimit
                    // };
                }
                var az = this.az;
                if (!az) {
                    this.az = _.get(list, '[0].AvailabilityZone');
                }
            }, (e) => {
                Message.error(e.msg || e);
            });
        },

        _fetchDedicatedPackage() {
            return this.$store.dispatch(commonConst.QueryProductGroups, {
                params: {
                    productGroupIdList: '277,276,136,139,101', //获取数据源（arm、gpu、专属宿主机、专属宿主机虚机、数据盘）
                    Region: this.regionKey
                }
            }).then((res) => {
                this.priceSet = res;
                this.initData();
            }, (e) => {
                Message.error(e.msg || e);
            });
        },

        initData() {
            var dedicatedObj = this.dedicatedObj;
            this._initData();
            if (_.isEmpty(dedicatedObj)) {
                var localDediInstance = localStorage.getItem('exclusiveObj');
                var _obj = localDediInstance && JSON.parse(localDediInstance);
                if (!_.isEmpty(_obj)) {
                    this.regionKey = _obj.regionKey;
                    this.az = _obj.AvailabilityZone;
                    this.azList = _.find(this.regionList, (ritem) => {
                        return ritem.regionCode == this.regionKey
                    }).azList
                    // this.dedicatedObj = _obj.DedicatedHostId;
                    this.dedicatedObj = _obj;
                    // let proplist = _.find(this.dedicatedPackage, (pitem) => {
                    //     return pitem.productTypeId == _obj.OrderInfo.ProductType
                    // }).propertyList
                    this.setKectypeListwithAz()
                } else {
                    this.regionKey = _.get(this.regionList, '[0].regionCode');
                    this.azList = _.get(this.regionList, '[0].azList');
                    // this.az = _.get(this.azList, '[0].azCode');
                    this.az = _.get(_.last(this.azList), 'azCode');
                    ;
                    this.setKectypeListwithAz()
                    // this.kecTypeList = JSON.parse((_.find(_.get(this.dedicatedPackage, '[0]propertyList', []), (item) => {
                    //     return item.propCode == 'vhostType';
                    // }) || {}).propValue || '[{"code":"","id":"","name":"未配置"}]');
                    // this.kecType = _.get(this.kecTypeList, '[0].id');
                }
                this._setDisk();
                this._setSysDisk();
            }
            this._fetchProjList();
            this.initDedicatedObj();
            this._setImageId();
            this.setKecTypeWithDedicated();
        },
        _initData() {
            // var data = [];
            // _.forEach(_.get(this.priceSet, 'data', []), (item) => {
            //     if (item.productGroupId == '136' || item.productGroupId == '276') {
            //         data = data.concat(item.productTypeList)
            //     }
            // });
            // this.dedicatedPackage = data;

            // var flattenRegionList = _.flatten(_.map(data, 'regionList'));
            // _.forEach(flattenRegionList, (item) => {
            //     item.areaCode = item.regionCode.split('-')[0];
            // });

            // this.regionList = _.unionBy(flattenRegionList, 'regionCode');

            let oriData = _.get(this.priceSet, 'data', []);
            var dedicatedData = _.find(oriData, (item) => {
                return item.productGroupId == '136'
            }) || {};
            var gpuDedicatedData = _.find(oriData, (item) => {
                return item.productGroupId == '276'
            }) || {};

            var data = dedicatedData.productTypeList || [];
            var gpuData = gpuDedicatedData.productTypeList || [];

            this.dedicatedPackage = data.concat(gpuData);

            var flattenRegionList = _.flatten(_.map(data, 'regionList'));
            var gpuFlattenRegionList = _.flatten(_.map(gpuData, 'regionList'));

            _.forEach(flattenRegionList, (item) => {
                item.areaCode = item.regionCode.split('-')[0];
            });

            _.forEach(gpuFlattenRegionList, (item) => {
                item.areaCode = item.regionCode.split('-')[0];
            });

            //追加GPU专属型配置的可用区
            _.forEach(flattenRegionList, (item) => {
                _.forEach(gpuFlattenRegionList, (subitem) => {
                    if (item.regionCode == subitem.regionCode) {
                        item.azList = _.orderBy(_.uniqBy(item.azList.concat(subitem.azList), 'azCode'), ['azCode'], ['asc']);
                    }
                });
            });

            let regionMap = new Map()
            _.forEach(flattenRegionList, item => {
                if(regionMap.has(item.regionCode)){
                    const azList = _.orderBy(_.unionBy([...regionMap.get(item.regionCode).azList, ...item.azList],'azCode'), ['azCode'], ['asc'])
                    regionMap.set(item.regionCode, {...regionMap.get(item.regionCode), azList})
                    return
                }
                regionMap.set(item.regionCode, item)
            })
            this.regionList = [...regionMap.values()]
            this.tryDoChunk('regionList', 'newRegionList')
            this.billTypeList = _.unionBy(_.flatten(_.map(data, 'billTypeList').concat([{
                billTypeId: 5,
                billTypeEnName: "dailySettlement",
                billTypeName: "按日月结"
            }])), 'billTypeId');
            this.billTypeList = _.filter(this.billTypeList, (item) => {
                return item.billTypeId == 5;
            }); //只能创建按日月结的虚机
            this.billType = _.get(this.billTypeList, '[0].billTypeId');
            this.tryDoChunk('billTypeList', 'newBillTypeList')
            //专属宿主机虚机
            // var vkdcGroupData = _.find(_.get(this.priceSet, 'data', []), (item) => {
            //     return item.productGroupId == '139'
            // }) || {};
            // this.vkdc_group_TypeList = vkdcGroupData.productTypeList || [];

            //专属宿主机虚机
            var vkdc_group_TypeList = [];
            _.forEach(_.get(this.priceSet, 'data', []), (item) => {
                if (item.productGroupId == '139' || item.productGroupId == '277') {
                    vkdc_group_TypeList = vkdc_group_TypeList.concat(item.productTypeList)
                }
            });
            this.vkdc_group_TypeList = vkdc_group_TypeList;

            //数据盘
            var ebsGroupData = _.find(_.get(this.priceSet, 'data', []), (item) => {
                return item.productGroupId == '101'
            }) || {};
            this.ebs_group_TypeList = ebsGroupData.productTypeList || [];
        },
        fetchAreaList(val) {
            if (val.length) {
                let areaList = [];
                let tempData = '';
                _.forEach(val, (item) => {
                    if (tempData != item.areaCode) {
                        areaList.push(_.filter(val, (subitem) => {
                            return subitem.areaCode == item.areaCode;
                        }) || []);
                    }
                    tempData = item.areaCode;
                });
                return areaList;
            }
        },
        filterAreaGroup(val, idx) {
            // if (val.length) {
            //     let i = idx - 1 ? idx : 0;
            //     if (idx > i) {
            //         let areaCodeArr = _.map(this.newRegionList[i], 'areaCode');
            //         return _.includes(areaCodeArr, val);
            //     }
            // }
            if (val.length) {
                let lineLeft = "line_left";
                let lineRight = "";
                let i = idx - 1 ? idx : 0;
                let j = idx + 1;
                if (idx > i) {
                    let iArr = _.map(this.newRegionList[i], 'areaCode');
                    lineLeft = _.includes(iArr, val) ? "" : "line_left";
                }
                if (val == _.last(this.newRegionList[idx]).areaCode) {
                    let jArr = _.map(this.newRegionList[j], 'areaCode');
                    lineRight = _.includes(jArr, val) ? "" : "line_right";
                }

                return lineLeft + " " + lineRight;
            }
        },
        setKectypeListwithAz() {
            let dedicatedObj = this.dedicatedObj, typelist = [];
            if (this.clusterObj && this.clusterObj != 'auto') {
                // console.log(this.clusterObj, 1111123132);
                // console.log(this.clusterAZList, 123144);
                let obj = _.find(this.clusterAZList, ['DedicatedClusterId', this.clusterObj]);
                if (obj) {
                    let model = obj.Model;
                    // console.log(this.dedicatedPackage,444);
                    let p = _.find(this.dedicatedPackage, ['packageList[0].packageCode', model]);
                    if (p) {
                        typelist = JSON.parse(p.propertyList[0].propValue)
                    }
                }
            } else if (_.has(dedicatedObj, "ProjectId")) {
                let propertyList = _.find(this.dedicatedPackage, (pitem) => {
                    return pitem.productTypeId == dedicatedObj.OrderInfo.ProductType
                }) || {}
                let proplist = propertyList ? propertyList.propertyList : [];
                // if (!_.isEmpty(proplist))
                //     typelist = JSON.parse(proplist[0].propValue)
                if (!_.isEmpty(proplist)) {
                    let propValue = _.get(proplist, '[0].propValue', []);
                    if (!_.isObject(propValue)) {
                        typelist = JSON.parse(propValue);
                    }
                }
            } else {
                _.forEach(this.dedicatedPackage, (item) => {
                    item.propertyList = _.filter(item.propertyList, (item1) => {
                        return item1.propCode == 'vhostType'
                    })
                    // typelist.push(JSON.parse(item.propertyList[0].propValue)[0])
                    let propValue = _.get(item.propertyList, '[0].propValue', []);
                    if (!_.isObject(propValue)) {
                        typelist.push(JSON.parse(propValue)[0]);
                    }
                })
                typelist = _.unionBy(typelist, 'id')
            }
            this.kecTypeList = typelist;
            this.kecType = _.get(this.kecTypeList, '[0].id');
            // if(this.sourcePage == 'osImageView'){
            //     const idLists = _.map(this.kecTypeList,item => item.id)

            //     for(let i=0;i<this.SupportProductTypes.length;i++){
            //         let productId = this.SupportProductTypes[i].productTypeId+''
            //         if(idLists.includes(productId)){
            //             this.kecType = productId
            //             break
            //         }

            //     }
            // }

            setTimeout(() => {
                // console.log(this.kecTypeList, 123123, this.kecType)
            }, 400);
        },
        setKecTypeWithDedicated() {
            var instance = this.dedicatedObj;
            let productType = _.get(instance, 'OrderInfo.ProductType');
            this.isDN2 = false;
            let clusterObj = this.clusterObj;
            if (clusterObj && clusterObj != 'auto') {
                _.forEach(this.clusterAZList, item => {
                    if (item.DedicatedClusterId === this.clusterObj && item.Model == 'DN2') {
                        this.isDN2 = true;
                    }
                })
            }

            // 数据盘为云盘机型：DN2、DS3、DR3、AG1、DS6
            this.hasEbsModel = _.includes([141, 189, 191, 602, 640], productType);

            if (!_.isEmpty(instance)) {
                this.onTrail = _.get(instance, 'OrderInfo.InstanceType') == 2 ? true : false;
                var _package = this.dedicatedPackage;
                var type = _.get(instance, 'OrderInfo.ProductType', '');
                var module = _.get(instance, 'Model', '');

                if (module == 'DN2') {
                    this.isDN2 = true;
                }
                var nowTypePackage = _.find(_package, (item) => {
                    return item.productTypeId == type;
                });
                this.setKectypeListwithAz()

                if (nowTypePackage) {
                    var nowModel = _.find(nowTypePackage.packageList, (item) => {
                        return item.packageCode == module;
                    });
                    if (nowModel) {
                        var isInRegion = _.find(nowModel.refRegionList, (item) => {
                            return (item.regionCode == this.regionKey) && ~_.indexOf(_.map(_.get(item, 'azList'), 'azCode'), this.az);
                        });
                        if (isInRegion) {
                            this.kecType = _.get(this.kecTypeList, '[0].id', '');
                        } else {
                            this.kecType = _.get(this.kecTypeList, '[0].id', '');
                        }
                    } else {
                        this.kecType = _.get(this.kecTypeList, '[0].id', '');
                    }
                } else {
                    this.kecType = _.get(this.kecTypeList, '[0].id', '');
                }
            } else {
                this.kecType = _.get(this.kecTypeList, '[0].id', '');
                this.onTrail = false;
            }
            if (this.sourcePage == 'osImageView') {
                const idLists = _.map(this.kecTypeList, item => item.id)

                for (let i = 0; i < this.SupportProductTypes.length; i++) {
                    let productId = this.SupportProductTypes[i].productTypeId + ''
                    if (idLists.includes(productId)) {
                        this.kecType = productId
                        break
                    }

                }
            }
            this._fetchDiyImg();
            this._fetchShareImg();
            this._setSysDisk();
            this._setDisk();
            this._setImageId();
            return this.exportData();
        },

        initDedicatedObj() {
            var regionKey = this.regionKey;
            this.azList = (_.find(this.regionList, (item) => {
                return item.regionCode == regionKey;
            }) || {}).azList || [];
            var az = this.az;
            if (!_.find(this.azList, (item) => {
                return item.azCode == az;
            })) {
                // this.az = _.get(this.azList, '[0].azCode');
                this.az = _.get(_.last(this.azList), 'azCode');
                ;

            }
            var data = this.azDedicateCollect;

            if (!_.find(data, (item) => {
                return item.DedicatedHostId == _.get(this.dedicatedObj, 'DedicatedHostId')
            })) {
                this.dedicatedObj = {
                    DedicatedHostId: '',
                    DedicatedHostName: this.$trans(`请选择`),
                    lessNum: this.dedicatedNumLimit,
                    _id: new Date() //校验
                };
            }
            return this.exportData();
        },

        //获取镜像部分
        _fetchOSImage() { //标准镜像
            return this.$store.dispatch(commonConst.OSImageList, {
                params: {
                    Region: this.regionKey
                }
            }).then((res) => {
                this.osImages = _.get(res, 'images', {});
                this.pTypeConfig = _.get(res, 'p_type_config', []);
                return this.formateOsImage();
            }, (e) => Message.error(e.msg || e));
        },
        _getRegionInfos() {
            return this.$store.dispatch(commonConst.RegionInfos, {
                params: {
                    Region: this.regionKey || 'cn-beijing-6'
                }
            }).then((res) => {

            }).catch((e) => {

            });
        },

        formateOsImage() {
            var regionKey = this.regionKey;
            var os = _.cloneDeep(this.osImages);
            var ImageList = [];

            if (this.pageLanguage == 'en') {
                _.forEach(os, (item) => {
                    _.forEach(item, (subItem) => {
                        if (subItem.imageEnName) {
                            subItem.imageName = subItem.imageEnName;
                        }
                    });
                });
            }

            _.mapKeys(os, (value, key) => {
                var obj = {
                    osType: key,
                    images: _.filter(value, (t) => {
                        return t.imageId;
                    })
                }
                ImageList.push(obj);
            });
            var GameImage = _.filter(ImageList, (item) => {
                return item.osType == "GameImage";
            });
            this.gameImageList = _.map(GameImage, (item) => {
                _.map(item.images, (img) => {
                    img.title = img.imageName;
                    img.value = img.imageId;
                    img.templateClass = 'icon icon-game-server-16 c-v-middle';
                    return img && img.imageId;
                });
                item.templateClass = 'icon icon-game-server-16 c-v-middle';
                return item;
            });
            var osImage = _.filter(ImageList, (item) => {
                return item.osType != "GameImage";
            });
            var images;

            // 标准镜像排序
            var osTypeOrder = ['centos', 'windows', 'ubuntu', 'fedora', 'debian', 'android', 'openeuler', 'rockylinux'];
            images = _.sortBy(osImage, function (item) {
                return _.indexOf(osTypeOrder, item.osType.toLowerCase());
            });
            // 镜像版本从高到低
            _.each(images, function (item) {
                item.images = _.sortBy(item.images, function (image) {
                    var version = image.imageVersion && image.imageVersion.match(/(\d+\.?)+/);
                    // 字符排序
                    return version;
                }).reverse();
            });
            this.osImageList = _.map(images, (item) => {
                _.map(item.images, (img) => {
                    img.title = img.imageName;
                    img.value = img.imageId;
                    img.templateClass = (item.osType || "").toLowerCase();
                    return img;
                });
                item.templateClass = (item.osType || "").toLowerCase();
                return item;
            });
            this._filterOsImage(this.osImageList)
        },

        _fetchDiyImg: _.debounce(function () {
            var self = this;
            return this.$store.dispatch(commonConst.ImageList, {
                params: {
                    Region: self.regionKey
                }
            }).then(() => {
                var imageSet = _.get(self, 'imageSet.ImagesSet', []);
                _.map(imageSet, (item) => {
                    item.imageName = item.Name;
                    item.imageId = item.ImageId;
                    return item;
                });
                this.diyImgList = _.filter(imageSet, (item) => {
                    return item.ImageState === 'active';
                });
            }, (e) => {
                Message.error(e.msg || e);
            });
        }, 500),
        _fetchShareImg: _.debounce(function (region) {
            let me = this;
            return this.$store.dispatch(step1Const.kecDiyImage, {
                params: {
                    Region: me.regionKey,
                    ImageType: 'share'
                },
                options: {
                    notAbort: true
                },
            }).then((res) => {
                var shareimageSet = _.get(res, 'ImagesSet', []);
                _.map(shareimageSet, (item) => {
                    item.imageName = item.Name;
                    item.imageId = item.ImageId;
                    return item;
                });
                this.shareImgList = _.filter(shareimageSet, (item) => {
                    return item.ImageState === 'active';
                });
                // this.shareImageListCopy = _.clone(this.shareImgList);
                if (this.imageType == 3) {
                    this._setImageId();
                }
            });
        }, 500),

        _filterOsImage(osList) {
            var res = osList;
            var pTypeConfig = this.pTypeConfig;
            var kecType = this.kecType ? this.kecType : 96;
            var isConfig = _.find(pTypeConfig, (item) => {
                return item.p_type == kecType;
            });

            // 按日计费试用 和 英文版控制台 不支持镜像市场
            let lang = commonCookie.getCookie("ksc_lang") || 'zh';
            if (this.orderBill == 2017 || lang == 'en') {
                this.isShowMarket = false;
            } else {
                this.isShowMarket = true;
            }

            var imageLimitList = [];
            if (!isConfig) {
                imageLimitList = [];
            } else {
                imageLimitList = isConfig.imageList || [];
            }
            if (kecType != '' && imageLimitList.length > 0 && this.imageType != 1) {
                var regexp = _.map(imageLimitList, function (item) {
                    return '(^' + item + '$)'
                }).join('|');
                regexp = new RegExp(regexp, 'i');
                res = _.filter(osList, (item) => {
                    item.images = _.filter(item.images, (img) => {
                        return regexp.test(img.imageVersion);
                    });
                    return !_.isEmpty(item.images);
                });
                this.osImageList = res;
                this._setImageId();
                return res;
            } else if (this.imageType == 1) {
                return res;
            } else {
                return res
            }
            // return res;
        },

        _setImageId() {
            var osList = [];
            if (this.imageType == 1) {
                osList = this.diyOsList;
            } else if (this.imageType == 3) {
                // osList = this.shareImageListCopy;
                osList = this.shareOsList;
            } else if (this.imageType == 4) {
                osList = [this.imageObj]
            } else if (this.imageType == 0) {
                osList = _.flatten(_.map(this.osImageList, 'images'));
            } else {
                osList = _.flatten(_.map(this.gameImageList, 'images'));
            }
            var imageId = this.imageId;
            var isNotChange = _.find(osList, (item) => {
                return imageId == item.imageId && !item.disabled;
            });
            // console.log(isChange ,11111111);
            if (osList.length > 0) {
                let showOsList = _.filter(osList, (item) => {
                    return !item.disabled
                });
                if (!isNotChange) {
                    this.$set(this, 'imageObj', _.get(showOsList, '[0]', {}));
                } else {
                    this.$set(this, 'imageObj', isNotChange);
                }
                if (this.sourcePage === 'osImageView') {
                    const obj = _.filter(this.SupportProductTypes, item => item.productTypeId == this.kecType)
                    if (obj && obj.length) {
                        this.imageId = this.osImageId;
                    } else {
                        this.imageId = ''
                    }

                }
                if (!this.imageId) {
                    this.imageId = _.get(showOsList, '[0].imageId', '');
                }
            } else {
                this.imageObj = {};
            }
            this._onImageChange();
        },
        //快照开机部分
        _setCanSnapCreate() {
            //是否支持快照开机功能
            var kecType = this.kecType;
            var regionKey = this.regionKey;
            //容器不支持快照开机
            // 弹性伸缩不支持快照开机
            // if (!~_.indexOf(["40", "137"], kecType) && !this.isGpu && !this.isCluster && !this.isAs) {
            // 137支持快照开机
            if (!~_.indexOf(["40", 40], kecType) && !this.isGpu && !this.isCluster && !this.isAs) {
                if (this.snapInfo.snapChoose) {
                    this.canSnapCreateDisk = false;
                } else {
                    this.canSnapCreateDisk = true;
                }
            } else {
                this.canSnapCreateDisk = false;
            }
        },
        checkSnap() {
            let me = this;

            let diskMax = _.get(this.model, 'disk') || 0;

            return _.map(this.snapList, (item) => {
                if (item.DiskSize < me.diskObj.minValue || item.DiskSize > diskMax) {
                    // item.trTitle = "提示：快照大小超出数据盘容量范围，请选择" + this.diskObj.minValue + "~" + this.diskObj.maxValue + "GB的快照或更改CPU内存";
                    item.trTitle = this.$trans(`提示：快照大小超出数据盘容量范围，请选择{0}~{1}GB的快照或更改CPU内存`, this.diskObj.minValue, diskMax);
                    item.disable = true;
                } else if (item.State.toUpperCase() != 'ACTIVE' && item.State.toUpperCase() != 'RESTORING') {
                    // item.trTitle = "提示：当前不支持处于" + this.common.nameMap(data.row.State) + "的快照";
                    item.trTitle = this.$trans(`提示：当前不支持处于{0}的快照`, this.snapNameMap[item.State.toLowerCase()]);
                    item.disable = true;
                } else {
                    item.trTitle = ''
                }
                return (item.DiskSize < me.diskObj.minValue || item.DiskSize > diskMax || (item.State != 'ACTIVE' && item.State != 'RESTORING'))
            })
        },
        checkEbsSnap() {
            let me = this;
            return _.map(me.ebsSnaps, (item, idx) => {
                if (item.Size < me.ebsDiskObjs[this.snapEbsIdx].minValue || item.Size > me.ebsDiskObjs[this.snapEbsIdx].maxValue) {
                    // item.trTitle = "提示：快照大小超出数据盘容量范围，请选择" + this.diskObj.minValue + "~" + this.diskObj.maxValue + "GB的快照或更改CPU内存";
                    item.trTitle = this.$trans(`提示：快照大小超出数据盘容量范围，请选择{0}~{1}GB的快照或更改CPU内存`, this.ebsDiskObjs[idx].minValue, this.ebsDiskObjs[this.snapEbsIdx].maxValue);
                    item.disable = true;
                } else if (item.SnapshotStatus.toLowerCase() != 'available') {
                    // item.trTitle = "提示：当前不支持处于" + this.common.nameMap(data.row.State) + "的快照";
                    // item.trTitle = this.$trans(`提示：当前不支持处于{0}的快照`, this.snapNameMap[item.State.toLowerCase()]);
                    item.trTitle = this.$trans(`当前仅支持状态处于可用的快照`);
                    item.disable = true;
                } else {
                    item.trTitle = ''
                }
                return (item.Size < me.ebsDiskObjs[this.snapEbsIdx].minValue || item.Size > me.ebsDiskObjs[this.snapEbsIdx].maxValue || (item.SnapshotStatus != 'available'))
            });
        },
        _snapCancel() {
            this.snapPage.current = 1;
            this.snapSearch = '';
            if (this.snapInfo.snapChoose) {
                this.canSnapCreateDisk = true;
                this.snapInfo.snapChoose = false;
                this.snapInfo = {
                    snapChoose: false,
                    snapId: '',
                    snapName: '',
                    snapCpacity: '',
                    showDelete: true,
                };
                this.limitNum = this.cloneLimitNum;
                this.diskSize = this.cloneDiskSize;
                this.snapBtnStatus = true;
            }
        },
        trMouseover(data) {
            let dom = '<div class="ui-tooltip">' + data.row.trTitle + '</div>';
            if (data.row.trTitle) {
                $('body').append(dom);
                this.$nextTick(() => {
                    $(".ui-tooltip").css({
                        top: $(document).scrollTop() + data.e.clientY,
                        left: data.e.clientX
                    })
                })
            }

        },
        trMouseout(data) {
            $('.ui-tooltip').remove()
        },
        //快照开机部分 end

        //改变产品类型
        _fetchKecType() {
            let me = this;
            let geneObj = _.find(this.generationList, ['generation', this.generation]);

            let kecTypeList = _.get(geneObj, 'products', []);
            let dropkecTypeList = [];
            _.each(kecTypeList, (item, idx) => {
                let enhanceObj = _.find(_.get(item.data[0], 'product.propertyList', []), ['propCode', 'is_net_support']);
                if (item.data[0].hanceKey && (!enhanceObj || !_.find(kecTypeList, ['productTypeId', item.data[0].hanceKey]))) {

                } else {
                    dropkecTypeList.push(item);
                }
            })
            this.kecTypeListAll = dropkecTypeList;
            this._fetchEnhance(dropkecTypeList);
            if (this.enhanceList.length > 0) {
                this.kecTypeList = _.sortBy(_.difference(dropkecTypeList, this.enhanceList), item => {
                    return (item.productTypeId == 40 || item.productTypeId == 137 || item.productTypeId == 138 ||
                        me.isSoldOutCheck(item.productTypeId))
                });
            } else {
                this.kecTypeList = _.sortBy(dropkecTypeList, item => {
                    return (item.productTypeId == 40 || item.productTypeId == 137 || item.productTypeId == 138 ||
                        me.isSoldOutCheck(item.productTypeId))
                });
            }
            let isExit = _.find(this.kecTypeList, item => {
                return item.productTypeId == me.kecType && !me.isSoldOutCheck(item.productTypeId);
            });
            if (!isExit) {
                this.kecType = this.kecTypeList[0].productTypeId;
            }
            if (this.isCluster) {
                // console.log(process.env.NODE_ENV, 111222)
                if (process.env.NODE_ENV == 'development') {
                    this.imageObj = {
                        imageName: 'CentOS-7.3 64位',
                        ImageId: 'd6c520a8-d9ad-419f-aaf3-ccc33d7a62e2',
                        title: 'CentOS-7.3 64位'
                    }
                    this.imageId = 'd6c520a8-d9ad-419f-aaf3-ccc33d7a62e2'
                } else {
                    this.imageObj = {
                        imageName: 'CentOS-7.3 64位',
                        ImageId: 'e6c6c90b-ac7e-427f-a3d5-7c27fc1bec17',
                        title: 'CentOS-7.3 64位'
                    }
                    this.imageId = 'e6c6c90b-ac7e-427f-a3d5-7c27fc1bec17'
                }
            }
            this._hasDiscount();
            if (!this.isCluster) this._fetchImageTypeList();
            this._judgeEnhance(kecTypeList);
        },
        _fetchEnhance(kecTypeList) {
            let enhanceList = [],
                me = this;
            _.each(kecTypeList, (item, idx) => {
                let enhanceObj = _.find(_.get(item.data[0], 'product.propertyList', []), ['propCode', 'propId']);
                let enhanceCode;
                if (enhanceObj) {
                    enhanceCode = enhanceObj.propValue[0].value;
                    let hanceKey = item.productTypeId;
                    let list = _.find(kecTypeList, (each) => {
                        if (each.productTypeId == enhanceCode) {
                            each.hanceKey = hanceKey;
                        }
                        return each.productTypeId == enhanceCode;
                    });
                    enhanceList.push(list);
                }
            });
            this.enhanceList = enhanceList;
        },
        // 改变集群信息
        clusterObjChange() {
            var list = this.dedicatedList || [];
            if (this.clusterObj && this.clusterObj == 'auto') {
                if (list.length != 0) {
                    _.forEach(list, (item) => {
                        item.lessNum = this.dedicatedNumLimit_src - _.get(item, 'Instances', []).length;
                        item.disabled = item.lessNum <= 0 ? true : (_.get(item, 'OrderInfo.Status') != 2 ? true : false);
                        if (item.OrderInfo.InstanceType == 2) {
                            return item.DedicatedHostName = item.DedicatedHostName + '(' + this.$trans(`试用`) + ')'
                        }
                    });
                }
            } else {
                let dedicatedHostsSet = _.find(this.clusterList, (item) => {
                    return item.AvailabilityZone == this.az && item.DedicatedClusterId == this.clusterObj;
                }).DedicatedHostsSet || [];
                let dedicatedHostIdArr = _.map(dedicatedHostsSet, 'DedicatedHostId');
                list = _.filter(list, (item) => {
                    return _.includes(dedicatedHostIdArr, item.DedicatedHostId);
                });
            }
            var azDedicateCollect = {};
            !_.isEmpty(list) && _.map(list, (item) => {
                var zone = item.AvailabilityZone;
                if (!azDedicateCollect[zone]) {
                    // if (this.clusterObj && this.clusterObj != 'auto') {
                    //     azDedicateCollect[zone] = [{
                    //         DedicatedHostId: 'auto',
                    //         DedicatedHostName: this.$trans(`自动分配`),
                    //         lessNum: 0 //this.dedicatedNumLimit
                    //     }];
                    // } else {
                    //     azDedicateCollect[zone] = [{
                    //         DedicatedHostId: '',
                    //         DedicatedHostName: this.$trans(`请选择`),
                    //         lessNum: this.dedicatedNumLimit
                    //     }];
                    // }
                    azDedicateCollect[zone] = [{
                        DedicatedHostId: '',
                        DedicatedHostName: this.$trans(`请选择`),
                        lessNum: this.dedicatedNumLimit
                    }];
                }
                // 下拉菜单只显示运行中状态的宿主机
                if (item.OrderInfo && item.OrderInfo.Status === 2) {
                    azDedicateCollect[zone].push(item);
                }
                // azDedicateCollect[zone].push(item);
                if (this.clusterObj && this.clusterObj != 'auto') {
                    azDedicateCollect[zone][0].lessNum += item.lessNum
                }
                return item;
            });
            // _.forEach(azDedicateCollect, (zoneData, zone) => {
            //     if (zoneData.length === 1 && zoneData[0].DedicatedHostId === 'auto') {
            //         azDedicateCollect[zone] = [{
            //             DedicatedHostId: '',
            //             DedicatedHostName: this.$trans(`请选择`),
            //             lessNum: this.dedicatedNumLimit
            //         }]
            //     }
            // });
            this.azDedicateCollect = azDedicateCollect;
            // if (this.dedicatedId == 'auto') {
            //     if (this.azDedicateCollect[this.az] && this.azDedicateCollect[this.az][1]) {
            //         this.dedicatedObj = this.azDedicateCollect[this.az][1]
            //     }
            // }
            if (this.azDedicateCollect[this.az] && this.azDedicateCollect[this.az][1]) {
                this.dedicatedObj = this.azDedicateCollect[this.az][1]
            }
        },
        kecTypeChange() {
            this.kecName = _.find(this.kecTypeList, ['productTypeId', this.kecType]).productTypeName;
            if (!this.isCluster) this._fetchImageTypeList();
            this._setCanSnapCreate();
            this._judgeEnhance();
        },
        _judgeEnhance() {
            let enhanceType = _.find(this.enhanceList, ['hanceKey', this.kecType]);
            if (enhanceType) {
                this.isHasEnhance = true;
                this.enhanceType = enhanceType;
            } else {
                this.isHasEnhance = false;
                this.isEnhance = false;
            }
            this._setKecType();
        },
        _setKecType() {
            if (this.isEnhance) {
                this._fetchCpu(this.enhanceType.productTypeId);
            } else {
                this._fetchCpu(this.kecType);
            }
        },
        //改变产品类型end
        //改变系统盘
        _setSysDisk() {
            let systemDiskTypes;
            let propertyList = (_.find(this.vkdc_group_TypeList, ['productTypeId', this.kecType * 1]) || {}).propertyList
            let sys = _.get(_.filter(propertyList, ['propCode', 'systemDisks'])[0], 'propValue', []);
            if (sys.length > 0) {
                systemDiskTypes = _.map(sys, function (item) {
                    return {
                        value: item.value,
                        title: item.name
                    };
                });
            } else {
                systemDiskTypes = [{
                    value: '',
                    title: this.$trans(`未配置系统盘`), //未配置系统盘
                }];
            }
            let productType = _.get(this.dedicatedObj, 'OrderInfo.ProductType');

            // 系统盘为云盘机型：DN2、DS3、DR3、DS6, 读取价格体系配置， 然后排查本地盘; GPU专属型可以忽略此处； GPU专属型即支持本地盘又支持云盘
            if (_.includes([141, 189, 191, 640], productType)) {
                // systemDiskTypes = [{
                //     title: this.$trans(`云硬盘3.0（SSD）`), //'云硬盘3.0(SSD)',
                //     value: 'SSD3.0',
                //     maxValue: 10,
                //     minValue: this.systemDisk.value,
                //     stepValue: 1
                // }, {
                //     title: this.$trans(`高效云盘`), //'高效云盘EHDD',
                //     value: 'EHDD',
                //     maxValue: 10,
                //     minValue: this.systemDisk.value,
                //     stepValue: 1
                // }];
                
                systemDiskTypes = _.filter(systemDiskTypes, (item) => {
                    return item.value != 'Local_SSD';
                });
            }

            // 系统盘列表排序
            let osTypeOrder = ['Local_SSD', 'SSD3.0', 'EHDD'];
            systemDiskTypes = _.sortBy(systemDiskTypes, function (item) {
                return _.indexOf(osTypeOrder, item.value.toUpperCase());
            });

            this.systemDiskTypes = systemDiskTypes;
            this.sysDiskObj = systemDiskTypes[0];
            this.sysDiskObjValue = this.sysDiskObj.value;
            this.systemDiskTypesCopy = systemDiskTypes;
            this._showSlider(this.sysDiskObjValue);
        },
        //是否使用调整系统盘大小滑竿
        _showSlider(data) {
            var isEbsSystemDisk = data.toLowerCase().indexOf('local') === -1;
            this.isEbsSystemDisk = isEbsSystemDisk; //非Local_SSD
            if (isEbsSystemDisk) {
                this.isShowSlider = true;
            } else {
                this.isShowSlider = false;
            }
        },
        //改变数据盘
        _setDisk() {
            let me = this;
            let diskTypes = this.diskTypes;
            let propertyList = (_.find(this.vkdc_group_TypeList, ['productTypeId', this.kecType * 1]) || {}).propertyList
            diskTypes = [{
                title: this.$trans(`本地SSD`), //'本地ssd数据盘',
                value: 'Local_SSD',
                maxValue: 50,
                minValue: 0,
                stepValue: 1
            }];
            this.diskTypes = diskTypes;
            this.diskObj = diskTypes[0];
            this.diskObjValue = this.diskObj.value;
            this.diskSize = Math.min(_.get(this.diskObj, 'maxValue'), Math.max(_.get(this.diskObj, 'minValue'), this.diskSize));
            this.maxEbsNum = _.get(_.find(propertyList, ['propCode', 'ebs-no']), 'propValue[0].max', 0);
            let ebsSupport = [];
            _.each(this.ebs_group_TypeList, item => {
                if ((_.filter(item.regionList, ['regionCode', me.regionKey]).length > 0) || me.orderBill == 2017) {
                    if ((item.packageList && item.packageList.length > 0 && _.filter(item.packageList[0].refRegionList, ['regionCode', me.regionKey]).length > 0) || me.orderBill == 2017) {
                        if (item.productTypeCode != 'SSD3.0' && item.productTypeCode != 'SATA3.0') {
                            if (this.hasEbsModel && item.productTypeCode === 'EHDD') {
                                // DN2可以用高效云盘
                            } else {
                                return;
                            }
                        }

                        let maxPackage = null;

                        _.forEach(item.packageList, item => {
                            if (!maxPackage) {
                                maxPackage = item;
                            } else {
                                let curMax = _.get(item, 'packageInfo[0].propValue[0].max');
                                let maxMax = _.get(maxPackage, 'packageInfo[0].propValue[0].max');
                                if (maxMax < curMax) {
                                    maxPackage = item;
                                }
                            }
                        });

                        ebsSupport.push({
                            value: item.productTypeCode,
                            productType: item.productTypeId,
                            title: me.allDiskNameMap[item.productTypeCode],
                            minValue: _.get(maxPackage, 'packageInfo[0].propValue[0].min', 0),
                            maxValue: _.get(maxPackage, 'packageInfo[0].propValue[0].max', 0),
                            stepValue: _.get(maxPackage, 'packageInfo[0].propValue[0].step' || 0)
                        });
                    }
                }
            });


            if (ebsSupport.length == 0) {
                // Message.error('未配置ebs-package，请联系客服')
            }

            this.ebsDiskSizeList = [];
            this.hadEbsDisk = 0;
            this.ebsSupport = ebsSupport;
            this.ebsDiskTypes = ebsSupport;
            this.ebsDiskObjs = [];
            this.ebsDiskObj = ebsSupport[0];
        },
        feachAssembledImageMeta() {
            let SnapshotSet = _.get(this.imageObj, 'SnapshotSet', []);
            let dataDisks = [];
            if (SnapshotSet && SnapshotSet.length) {
                dataDisks = _.filter(SnapshotSet, (item) => {
                    return item.Type == "data";
                });
            }
            if (dataDisks.length && (this.imageType == 1 || this.imageType == 3)) { //暂时只开放自定义镜像、共享镜像 支持整机镜像

                let localSnapshot = _.filter(dataDisks, (item) => {
                    return item.DiskType == "local_snapshot";
                });
                let noLocalSnapshot = _.filter(dataDisks, (item) => {
                    return item.DiskType != "local_snapshot";
                });
                dataDisks = noLocalSnapshot;
                if (localSnapshot && localSnapshot.length) {
                    this.diskSize = _.get(localSnapshot, '[0].DiskSize');
                    this.canSnapCreateDisk = false;
                    this.snapInfo = {
                        snapChoose: true,
                        snapName: _.get(localSnapshot, '[0].SnapshotId'),
                        snapCpacity: _.get(localSnapshot, '[0].DiskSize'),
                        showDelete: false,
                        snapId: _.get(localSnapshot, '[0].SnapshotId'),
                    }
                } else {
                    this.canSnapCreateDisk = true;
                    this.snapInfo = {
                        snapChoose: false,
                        snapName: '',
                        snapCpacity: '',
                        showDelete: true,
                        snapId: ''
                    }
                }
                this.assembledImageMetaNum = dataDisks.length;
                this.snapCreateDiskList(dataDisks);
            } else {
                this.canSnapCreateDisk = true;
                this.snapInfo = {
                    snapChoose: false,
                    snapName: '',
                    snapCpacity: '',
                    showDelete: true,
                    snapId: ''
                }
                this.assembledImageMetaNum = 0;
                this.ebsDiskSizeList = [];
                this.delWithInsList = [];
                this.hadEbsDisk = 0;
                this.ebsDiskObjs = [];
                this.ebsSnapList = [];
            }
        },
        snapCreateDiskList(dataDisks) {
            let snapFilterList = [];
            let snapshots = [];
            let _data = {
                Marker: 0,
                MaxResults: 1000,
                LocalVolumeCategory: ''
            };

            let _snapCreateLocalDisk = this.$store.dispatch(step1Const.kecGetSnap, {
                params: {
                    Region: this.regionKey
                },
                options: {
                    isJSON: true,
                    showLoading: true
                },
                data: _data
            });

            let _snapCreateEbsDisk = this.$store.dispatch(step1Const.getEbsSnap, {
                params: {
                    Region: this.regionKey,
                    // AvailabilityZone: this.azCode, //整机镜像是不区分可用区的
                    VolumeCategory: '', //获取系统盘和数据盘快照
                    SnapshotName: '',
                    PageNumber: 1,
                    PageSize: 1000
                }
            });

            Promise.all([_snapCreateLocalDisk, _snapCreateEbsDisk]).then(([data, __data]) => {
                if (data && data.LocalVolumeSnapshotSet.length) {
                    snapFilterList = data.LocalVolumeSnapshotSet
                }

                if (__data && __data.Snapshots.length) {
                    snapshots = __data.Snapshots;
                }
                snapFilterList = snapFilterList.concat(snapshots);

                //过滤掉不合规的镜像
                snapFilterList = _.filter(snapFilterList, (item) => {
                    return !item.disable
                });

                this.ebsDiskSizeList = [];
                this.delWithInsList = [];
                this.hadEbsDisk = 0;
                this.ebsDiskObjs = [];
                this.ebsSnapList = [];

                if (this.snapInfo.snapId) {
                    // 查询本地盘快照名称
                    let tempDataSnapshotName = _.find(snapFilterList, (subitem) => {
                        return subitem.LocalVolumeSnapshotId == this.snapInfo.snapId;
                    }) || {};
                    this.snapInfo.snapName = (tempDataSnapshotName && tempDataSnapshotName.LocalVolumeSnapshotName) || '共享快照默认名称';
                }

                _.forEach(dataDisks, (item) => {
                    var idx = _.findIndex(this.ebsSupport, ['value', 'SSD3.0']); // 默认SSD3.0
                    if (idx != -1) {
                        let tempData = _.find(snapFilterList, (subitem) => {
                            return subitem.LocalVolumeSnapshotId == item.SnapshotId || subitem.SnapshotId == item.SnapshotId;
                        }) || {};
                        // if ((_.get(tempData, 'LocalVolumeSnapshotId', '') || _.get(tempData, 'SnapshotId', '')) && item.Type == 'data') {
                        //     item.name = tempData.LocalVolumeSnapshotName || tempData.SnapshotName;
                        //     this.ebsDiskObj = this.ebsSupport[idx];
                        //     this._addEbsDisk('undefined', item.DiskSize, true, item);
                        // }
                        if (item.Type == 'data') {
                            item.name = tempData.LocalVolumeSnapshotName || tempData.SnapshotName || '共享快照默认名称'; //如果是共享的快照， 那么是找不到对应快照名称的
                            this.ebsDiskObj = this.ebsSupport[idx];
                            if (item.DiskType !== 'local_snapshot') {
                                this._addEbsDisk('undefined', item.DiskSize, true, item);
                            }
                        }
                    }
                });
            })
        },
        _reduceEbsDisk(index) {
            var hadEbsNum = this.hadEbsDisk;
            var diskSize = this.ebsDiskSizeList;
            diskSize.splice(index, 1);
            this.delWithInsList.splice(index, 1);
            this.ebsDiskObjs.splice(index, 1);
            this.$set(this, 'hadEbsDisk', --hadEbsNum);
        },
        _addEbsDisk(MouseEvent, modelDiskSize, modelDeleteWithInstance, data) {
            var max = this.maxEbsNum;
            var hadEbsNum = this.hadEbsDisk;
            var diskSize = this.ebsDiskSizeList;
            if (hadEbsNum < max) {
                modelDiskSize ? this.delWithInsList.push(modelDeleteWithInstance) : this.delWithInsList.push(false);
                modelDiskSize ? diskSize.push(modelDiskSize) : diskSize.push(10); //修改数据盘默认为10G
                if (data && data.DiskSize) {
                    this.ebsSnapList.push({
                        snapChoose: true,
                        snapName: data.name,
                        snapCpacity: data.DiskSize,
                        snapId: data.SnapshotId,
                        type: 'SSD3.0',
                        dataDiskType: 'SSD3.0'
                    })
                } else {
                    this.ebsSnapList.push({
                        snapChoose: false,
                        snapName: '',
                        snapCpacity: '',
                        snapId: '',
                        type: '',
                        dataDiskType: data ? (data.type || 'SSD3.0') : 'SSD3.0'
                    })
                }

                this.ebsDiskObjs.push(_.cloneDeep(this.ebsDiskObj));
                this.$set(this, 'hadEbsDisk', ++hadEbsNum);
            }
        },
        _fixNum() {
            this.diskSize = +this.diskSize;
            var l = this.hadEbsDisk;
            if (l > 0) {
                for (var i = 0; i < l; i++) {
                    this.ebsDiskSizeList[i] = +this.ebsDiskSizeList[i];
                }
                this.ebsDiskSizeList = _.cloneDeep(this.ebsDiskSizeList);
            }
        },
        // _snapCreate() {
        //     this.cloneDiskSize = this.diskSize;
        //     this.$store.dispatch(commonConst.snapList, {
        //         params: {
        //             Region: this.regionKey
        //         },
        //         options: {
        //             isJSON: true,
        //             showLoading: true
        //         },
        //         data: {
        //             Marker: (this.snapPage.current - 1) * this.snapPage.rowsPerPage,
        //             MaxResults: this.snapPage.rowsPerPage,
        //             Search: this.snapSearch,
        //             LocalVolumeCategory: 'data'
        //         }
        //     }).then(res => {
        //         if (this.snapListTotal < this.snapPage.rowsPerPage && this.snapPage.current > 1) {
        //             this.snapPage.current = 1;
        //             return this._snapCreate();
        //         }
        //         this.snapPage.totalRows = this.snapListTotal;
        //         this.isSnapCreateDisk = true;
        //         this.$nextTick(() => {
        //             $(".dedicateDialog .ks-vue-ui-table-kvm-header .ks-table colgroup col").eq(4).remove();
        //             $(".dedicateDialog .ks-vue-ui-table-kvm-body .ks-table colgroup col").eq(4).remove();
        //             $(".dedicateDialog .ks-vue-ui-table-kvm-header .ks-table colgroup col").eq(4).remove();
        //             $(".dedicateDialog .ks-vue-ui-table-kvm-body .ks-table colgroup col").eq(4).remove();
        //         })
        //     }).catch(e => {
        //         Message.error(e);
        //         this.isSnapCreateDisk = false;
        //     });
        // },
        _snapCreate() {
            this.cloneDiskSize = this.diskSize;
            let params = {
                'type': 'snapCreateLocalDisk',
                'regionKey': this.regionKey,
                'diskObj': this.diskObj,
            };
            this.$refs.snapCreateDia.handle(params);
        },
        _onImageChange: function () { //镜像改变会改变系统盘
            var self = this;
            var imageObj = self.imageObj;

            // 没有镜像
            if (!imageObj || _.isEmpty(imageObj)) {
                return;
            }

            let imageVersion = imageObj ? (imageObj.imageVersion || imageObj.Platform) : 0;
            let isAndroidImage = /android.*/i.test(imageVersion.toLowerCase());
            this.isAndroidImage = isAndroidImage;
            var cloudOsType,
                isWindows = false,
                isWin2008 = false,
                isUbuntu = false,
                sysDisk = 0;
            if (self.imageType === 0) {
                // 标准镜像和
                cloudOsType = imageObj.imageVersion;
                isWindows = /win.*/i.test(cloudOsType.toLowerCase());
                isWin2008 = /win.*2008/i.test(imageObj && imageObj.imageVersion);
                isUbuntu = /ubuntu/i.test(imageObj && imageObj.imageVersion);
            } else if (self.imageType === 1 || self.imageType === 3 || self.imageType === 4) {
                // 自定义镜像
                cloudOsType = imageObj.Platform;
                sysDisk = imageObj.SysDisk || 0;
                isWindows = /windows/.test(cloudOsType);
                isWin2008 = /win.*2008/i.test(cloudOsType);
                isUbuntu = /ubuntu/i.test(cloudOsType);
                sysDisk = imageObj.SysDisk;
            } else if (self.imageType === 2) {
                sysDisk = imageObj.SysDisk;
                //游戏云镜像
                cloudOsType = imageObj.imageVersion;
                isWindows = /win.*/i.test(cloudOsType.toLowerCase());
                isUbuntu = /ubuntu/i.test(cloudOsType.toLowerCase());
            }
            // 是否是windows系统的标识
            this.isWindows = isWindows;
            this.isWin2008 = isWin2008;
            this.isUbuntu = isUbuntu;
            var sysDiskType = commonConst.isCommonModelType(this.kecType) ? 'ebs_ssd' : 'ssd';

            let sysDiskVal = isWin2008 ? 40 : (isWindows ? 50 : (this.kecType == '603' && isAndroidImage) ? 5 : 20); //isWin2008 ? 40 : (isWindows ? 50 : 20)//gpu专属型(603)的安卓系统最小是5G
            if (self.imageType === 1 || self.imageType === 3) {
                sysDiskVal = imageObj.SysDisk;
                if (!this.hasEbsModel && imageObj.SnapshotSet && imageObj.SnapshotSet.length > 1) {
                    this.model.disk = imageObj.SnapshotSet[imageObj.SnapshotSet.length - 1].DiskSize
                    this.snapInfo.snapChoose = true
                    this.snapInfo.showDelete = false
                } else {
                    this.model.disk = 0;
                    this.snapInfo.snapChoose = false
                    this.snapInfo.showDelete = true
                }
            } else if (self.imageType === 4) {
                sysDiskVal = _.get(imageObj, "imageDetail.minDisk", 20)
            }

            this.systemDisk = {
                type: sysDiskType,
                max: 500,
                min: isWin2008 ? 40 : (isWindows ? 50 : (this.kecType == '603' && isAndroidImage) ? 5 : 20), //isWin2008 ? 40 : (isWindows ? 50 : 20), //gpu专属型(603)的安卓系统最小是5G
                value: sysDiskVal,
                user: isUbuntu ? 'ubuntu' : (isWindows ? 'kingsoft' : 'root'),
                sys: isWindows ? 'windows' : 'linux'
            };

            // Gpu专属型云盘系统盘限制, 可变系统盘最小值，安卓镜像时最小5，CentOS镜像时最小20
            if (this.kecType == '603') {
                this.systemDiskMin = isAndroidImage ? 5 : 20;
            }

            // 当自定义镜像硬盘大于赠送硬盘大小时，获取较大值
            // console.log(self.imageType, imageObj, sysDisk, this.systemDisk.value,123);
            let sysDistValue = (sysDisk > this.systemDisk.value) ? sysDisk : this.systemDisk.value;
            let rem = sysDistValue % this.systemDiskStep;
            rem ? (this.systemDiskMin = (sysDistValue - rem + 10)) : (this.systemDiskMin = sysDistValue);

            // console.log(rem ? (sysDistValue - rem + 10) : sysDistValue, 1111111111111111111111111);
            // console.log(this.systemDiskMin, 11111);
            this.systemDiskObj = {
                minValue: this.systemDiskMin,
                maxValue: this.systemDiskMax
            }

            return this.exportData();
        },

        dedicateCpuCal: function () {
            var instance = this.dedicatedObj;
            var nowCpu = this.model.cpu;
            var lessCpu = instance.AvailableCpu;
            var limitNum = this.model.dedicateCount;
            if (instance) {
                this.dedicatelimitCal();
                return nowCpu * limitNum <= lessCpu;
            }
        },
        // 底层限制，超线程问题，如果单台机器的核数超过实际核数，开出的资源实际也只有oricpu的核数
        dedicateActualCpuCal: function () {
            var instance = this.dedicatedObj;
            var nowCpu = this.model.cpu;
            var actualCpu = _.get(instance, 'OriCpu', 0); //实际核数
            var limitNum = this.model.dedicateCount;
            if (instance) {
                this.dedicatelimitCal();
                return nowCpu <= actualCpu;
            }
        },
        dedicateMemCal: function () {
            var instance = this.dedicatedObj;
            var nowMem = this.model.mem;
            var lessMem = instance.AvailableMemory;
            var limitNum = this.model.dedicateCount;
            if (instance) {
                this.dedicatelimitCal();
                if (this.kecType == '603') {
                    return nowMem * limitNum <= lessMem && nowMem < 255; // AG1机型需要多加一个限制，单台内存不能超过255G
                }
                return nowMem * limitNum <= lessMem;
            }
        },
        dedicateDiskCal: function () {
            var instance = this.dedicatedObj;
            var nowDiskSize = this.model.disk;
            var lessSize = instance.AvailableDatadisk;
            var limitNum = this.model.dedicateCount;
            if (instance) {
                this.dedicatelimitCal();
                return nowDiskSize * limitNum <= lessSize;
            }
        },
        dedicatelimitCal: function () {
            var instance = this.dedicatedObj;
            var actualCpu = _.get(instance, 'OriCpu', 0); //实际核数
            var cpu = this.model.cpu;
            var lessCpu = instance.AvailableCpu;
            var mem = this.model.mem;
            var lessMem = instance.AvailableMemory;
            var size = this.model.disk;
            var lessSize = instance.AvailableDatadisk;
            var count = this.model.dedicateCount;
            if (instance.DedicatedHostId) {
                if (cpu) {
                    if (cpu * count > lessCpu) {
                        this.dedicatedNumLimit = Math.min(Math.floor(lessCpu / cpu), this.dedicatedNumLimit_src);
                        return false;
                    }
                }
                if (cpu) {
                    if (cpu > actualCpu) {
                        this.dedicatedNumLimit = Math.min(Math.floor(actualCpu / cpu), this.dedicatedNumLimit_src);
                        return false;
                    }
                }
                if (mem) {
                    if (mem * count > lessMem) {
                        this.dedicatedNumLimit = Math.min(Math.floor(lessMem / mem), this.dedicatedNumLimit_src);
                        return false;
                    }
                }
                // if (this.isSnapToCreate) {
                if (_.get(this.snapInfo, 'snapChoose', false)) {
                    var snapSize = this.snapObj.DiskSize;
                    if (snapSize * count > lessSize) {
                        this.dedicatedNumLimit = Math.min(Math.floor(lessSize / snapSize), 20, this.dedicatedNumLimit);
                        // (+this.snapNum + 1) del this xor 20
                        return false;
                    }
                } else {
                    if (size) {
                        if (size * count > lessSize) {
                            this.dedicatedNumLimit = Math.min(Math.floor(lessSize / size), this.dedicatedNumLimit_src);
                            return false;
                        }
                    }
                }
            }

            return true;
        },
        //调取集群接口
        _fetchExCluster: function () {
            return this.$store.dispatch(commonConst.getDedicatedCluster, {
                options: {
                    isJSON: true,
                },
                params: {
                    Region: this.regionKey
                },

            }).then((res) => {
                this.clusterList = res.DedicatedClustersSet
                this._filterCluster()
                return this.clusterList;
            }).catch(e => {
                Message.error(e.msg || e);
            });
        },
        //选择az时根据az过滤集群
        _filterCluster() {
            let list = _.filter(this.clusterList, (item) => {
                return item.AvailabilityZone == this.az
            });
            this.clusterAZList = [{
                DedicatedClusterId: 'auto',
                DedicatedClusterName: Vue.$trans(`自动分配`)
            }].concat(list);
            this.clusterObj = _.get(this.clusterAZList, '[0].DedicatedClusterId') || ''
            this.initDedicatedObj()
        },
        // //计算价格
        // _snapCreateEbs(key) {
        //     this.$store.dispatch(commonConst.getEbsSnap, {
        //         params: {
        //             Region: this.regionKey,
        //             AvailabilityZone: this.az,
        //             VolumeCategory: "data",
        //             SnapshotName: this.snapSearchEbs,
        //             PageNumber: this.snapEbsPage.current,
        //             PageSize: this.snapEbsPage.rowsPerPage
        //         }
        //     }).then(res => {
        //         this.ebsSnaps = res.Snapshots;
        //         this.snapEbsPage.totalRows = _.get(res.Page, 'totalCount', 0);
        //         if (_.get(res.Page.totalCount, 0) < this.snapEbsPage.rowsPerPage && this.snapEbsPage.current > 1) {
        //             this.snapEbsPage.current = 1;
        //             return this._snapCreateEbs();
        //         }
        //         this.isSnapCreateEbs = true;
        //         this.snapEbsIdx = key
        //     }).catch(e => {
        //         commonAlert.send('请求创建EBS接口报错', 'kecDanger');
        //         this.isSnapCreateEbs = false;
        //     })
        // },
        checkSnapShotService(name, key) {
            if (name == '_snapCreateEbs') {
                this._snapCreateEbs(key);
            } else if (name == '_snapCreate') {
                this._snapCreate();
            }
        },
        _snapCreateEbs(key) {
            let params = {
                'type': 'snapCreateEbsDisk',
                'key': key,
                'regionKey': this.regionKey,
                'ebsDiskObjs': this.ebsDiskObjs,
                'azCode': this.az,
                'kecType': this.kecType,
                'dataDiskType': this.ebsSnapList[key].dataDiskType,
            };
            this.$refs.snapCreateDia.handle(params);
        },
        _snapCancelEbs(key) {
            this.snapEbsPage.current = 1;
            this.snapEbsIdx = key;
            this.ebsDiskSizeList[key] = 10;
            this.delWithInsList[key] = false;
            const resetObj = {
                snapId: '',
                snapName: '',
                snapCpacity: '',
                type: '',
                snapChoose: false
            }
            Object.assign(this.ebsSnapList[key], resetObj)
            this.ebsDiskObjs[key].minValue = 10;
            // this.calcuPrice();
        },
        _setSnapEle(data) {
            // console.log(data, "_setSnapEle");
            if (!data.disable) {
                if (data.snaptype == "snapCreateEbsDisk") { //用快照创建云盘
                    this.ebsSnapListClone[data.snapEbsIdx] = {};
                    this.ebsSnapListClone[data.snapEbsIdx].snapId = data.LocalVolumeSnapshotId || data.SnapshotId;
                    this.ebsSnapListClone[data.snapEbsIdx].snapName = data.LocalVolumeSnapshotName || data.SnapshotName;
                    this.ebsSnapListClone[data.snapEbsIdx].snapCpacity = data.MinDisk || data.Size || 0;
                    this.ebsSnapListClone[data.snapEbsIdx].snapChoose = true;
                    // 不根据选中的快照类型重置数据盘类型
                    // this.ebsSnapListClone[data.snapEbsIdx].dataDiskType = data.VolumeType || 'SSD3.0';
                    this.ebsSnapListClone[data.snapEbsIdx].VolumeCategory = data.SourceLocalVolumeCategory || data.VolumeCategory;
                    this.ebsSnapListClone[data.snapEbsIdx].SnapshotType = data.LocalVolumeSnapshotId ? 'local_snapshot' : 'clould_snapshot';

                    // this.ebsSnapList[data.snapEbsIdx] = this.ebsSnapListClone[data.snapEbsIdx];
                    // 选中的快照数据覆盖原有的数据盘数据
                    Object.assign(this.ebsSnapList[data.snapEbsIdx], this.ebsSnapListClone[data.snapEbsIdx])
                    this.ebsDiskSizeList[data.snapEbsIdx] = this.ebsSnapList[data.snapEbsIdx].snapCpacity;
                    if (this.ebsDiskObjs[data.snapEbsIdx].minValue < this.ebsSnapList[data.snapEbsIdx].snapCpacity || this.ebsDiskObjs[data.snapEbsIdx].minValue > this.ebsDiskObjs[data.snapEbsIdx].maxValue) {
                        this.ebsDiskObjs[data.snapEbsIdx].minValue = this.ebsSnapList[data.snapEbsIdx].snapCpacity;
                    }
                    this.ebsDiskSizeList = _.cloneDeep(this.ebsDiskSizeList);

                    setTimeout(() => {
                        let ele = $(this.$el).find(`[name="ebsDisk${data.snapEbsIdx}"]`)
                        ele.valid();
                    }, 200);

                    if (this.kecCount > this.limitNum) {
                        this.kecCount = this.limitNum;
                    }
                    // this.calcuPrice();
                }
                if (data.snaptype == "snapCreateLocalDisk") { //用快照创建本地盘
                    this.snapInfoClick.snapId = data.LocalVolumeSnapshotId;
                    this.snapInfoClick.snapName = data.LocalVolumeSnapshotName;
                    this.snapInfoClick.snapCpacity = data.MinDisk || 0;
                    this.snapInfoClick.dataDiskType = 'SSD3.0';

                    this.canSnapCreateDisk = false;
                    this.snapInfo.snapId = this.snapInfoClick.snapId;
                    this.snapInfo.snapName = this.snapInfoClick.snapName;
                    this.snapInfo.snapCpacity = this.snapInfoClick.snapCpacity;
                    this.snapInfo.dataDiskType = this.snapInfoClick.dataDiskType;
                    this.snapInfo.snapChoose = true;
                    this.diskSize = this.snapInfo.snapCpacity;
                    if (this.diskObj.minValue < this.diskSize || this.diskObj.minValue > this.diskObj.maxValue) {
                        this.diskObj.minValue = this.diskSize;
                    }
                    this.snapInfo = _.cloneDeep(this.snapInfo);
                    if (this.kecCount > this.limitNum) {
                        this.kecCount = this.limitNum;
                    }
                }

            }
        },
        snapEbsClick(val) {
            if (!val.row.disable) {
                this.ebsSnapListClone[this.snapEbsIdx] = {};
                this.ebsSnapListClone[this.snapEbsIdx].snapId = val.row.SnapshotId;
                this.ebsSnapListClone[this.snapEbsIdx].snapName = val.row.SnapshotName;
                this.ebsSnapListClone[this.snapEbsIdx].snapCpacity = val.row.Size;
                this.ebsSnapListClone[this.snapEbsIdx].snapChoose = true;
                this.snapBtnEbsStatus = false;
            }
        },

        //计算价格end
        _cloudMarket(regionKey) {
            let quotaMaxDisk = 500; //实际是没有限制
            let systemDiskMax = _.get(this.systemDisk, 'max', 0);
            this.$refs.cloudmarketDia.handle("dedicate", this.res, regionKey, quotaMaxDisk, systemDiskMax, this.sysDiskObj);
        },
        _setimagesname(data) {
            data.title = data.name
            data.value = data.imageId
            this.imageObj = data
            // if(!this.imageId){
            //     this.imageId = this.imageObj.value
            // }
            this._setImageId();
        }
    },
    beforeDestroy() {
        localStorage.setItem('exclusiveObj', '{}');
    },
}
